export interface QuizQuestion {
  id: number;
  city: string;
  category: 'geography' | 'history' | 'finance';
  question: string;
  options: string[];
  answer: number;
  explanation: string;
}

const RAW_QUIZ_QUESTIONS: QuizQuestion[] = [
  // ========== 北京 ==========
  {
    id: 1,
    city: '北京',
    category: 'history',
    question: '北京作为都城的历史悠久，下列朝代中曾以北京为都的是？',
    options: ['唐朝', '宋朝', '元朝', '西周'],
    answer: 2,
    explanation: '元朝定都大都，即今天的北京。唐朝都城为长安（今西安），北宋都城为东京（今开封），西周都城为镐京（今西安附近）。'
  },
  {
    id: 3,
    city: '北京',
    category: 'history',
    question: '明成祖朱棣迁都北京的具体时间是？',
    options: ['1368年', '1403年', '1421年', '1644年'],
    answer: 2,
    explanation: '1421年明成祖朱棣正式迁都北京，改北平为京师。1368年是明朝建立时间，1403年朱棣改北平为北京，1644年是明朝灭亡时间。'
  },
  {
    id: 4,
    city: '北京',
    category: 'history',
    question: '故宫又称紫禁城，是明清两代的皇宫，其始建年代为？',
    options: ['元至元年', '明永乐年', '清顺治年', '明洪武年'],
    answer: 1,
    explanation: '故宫始建于明永乐四年（1406年），永乐十八年（1420年）建成，是明成祖朱棣迁都北京后修建的皇宫。'
  },
  {
    id: 5,
    city: '北京',
    category: 'history',
    question: '下列事件发生于北京的是？',
    options: ['五四运动', '南昌起义', '辛亥革命', '甲午海战'],
    answer: 0,
    explanation: '1919年五四运动爆发于北京，是中国新民主主义革命的开端。南昌起义发生在南昌，辛亥革命以武昌起义为标志，甲午海战发生在黄海海域。'
  },
  {
    id: 6,
    city: '北京',
    category: 'geography',
    question: '北京的气候类型属于？',
    options: ['亚热带季风气候', '温带季风气候', '温带大陆性气候', '高原山地气候'],
    answer: 1,
    explanation: '北京位于我国北方地区，属于典型的温带季风气候，夏季高温多雨，冬季寒冷干燥。'
  },
  {
    id: 7,
    city: '北京',
    category: 'geography',
    question: '流经北京的主要河流是？',
    options: ['海河支流永定河', '黄河', '滦河', '辽河'],
    answer: 0,
    explanation: '永定河是海河水系的重要支流，流经北京西部地区，被称为北京的"母亲河"。'
  },
  {
    id: 8,
    city: '北京',
    category: 'geography',
    question: '北京地处哪两大地理区域的过渡地带？',
    options: ['黄土高原与华北平原', '华北平原与内蒙古高原', '青藏高原与云贵高原', '四川盆地与长江中下游'],
    answer: 1,
    explanation: '北京位于华北平原北部，北面是燕山山脉，越过燕山就是内蒙古高原，因此处于华北平原与内蒙古高原的过渡地带。'
  },
  {
    id: 9,
    city: '北京',
    category: 'geography',
    question: '北京所在的地形区主要是？',
    options: ['黄土高原', '华北平原', '东北平原', '内蒙古高原'],
    answer: 1,
    explanation: '北京位于华北平原的西北端，西部和北部为山地，东南部属于华北平原。'
  },
  {
    id: 10,
    city: '北京',
    category: 'history',
    question: '举办2008年夏季奥运会的城市是？',
    options: ['伦敦', '东京', '北京', '雅典'],
    answer: 2,
    explanation: '2008年第29届夏季奥林匹克运动会在北京举办，这是中国首次举办夏季奥运会。'
  },

  // ========== 上海 ==========
  {
    id: 12,
    city: '上海',
    category: 'geography',
    question: '上海所临的海是？',
    options: ['渤海', '黄海', '东海', '南海'],
    answer: 2,
    explanation: '上海位于长江入海口，东临东海。长江口以北为黄海，以南为东海。'
  },
  {
    id: 13,
    city: '上海',
    category: 'geography',
    question: '上海的母亲河是？',
    options: ['黄浦江', '苏州河', '长江', '钱塘江'],
    answer: 0,
    explanation: '黄浦江流经上海市区，将上海分为浦东和浦西，是上海最重要的河流，被誉为上海的母亲河。'
  },
  {
    id: 14,
    city: '上海',
    category: 'geography',
    question: '上海所在的地理区位优势主要体现在？',
    options: ['内陆腹地', '长江入海口', '黄河三角洲', '珠江三角洲'],
    answer: 1,
    explanation: '上海位于长江入海口，地处我国大陆海岸线中点，河海联运便利，是我国最大的港口城市和经济中心。'
  },
  {
    id: 15,
    city: '上海',
    category: 'geography',
    question: '上海的气候类型是？',
    options: ['亚热带季风气候', '温带季风气候', '热带季风气候', '温带海洋性气候'],
    answer: 0,
    explanation: '上海位于秦岭-淮河以南，属于亚热带季风气候，夏季高温多雨，冬季温和少雨。'
  },
  {
    id: 16,
    city: '上海',
    category: 'history',
    question: '上海正式开埠通商是在下列哪个条约签订之后？',
    options: ['《南京条约》', '《北京条约》', '《马关条约》', '《辛丑条约》'],
    answer: 0,
    explanation: '1842年《南京条约》规定开放广州、厦门、福州、宁波、上海五处为通商口岸，上海由此开埠。'
  },
  {
    id: 17,
    city: '上海',
    category: 'history',
    question: '中国共产党第一次全国代表大会召开地点是？',
    options: ['北京', '广州', '上海', '武汉'],
    answer: 2,
    explanation: '1921年7月，中国共产党第一次全国代表大会在上海召开，标志着中国共产党的诞生。'
  },
  {
    id: 18,
    city: '上海',
    category: 'history',
    question: '上海浦东开发开放始于哪一年？',
    options: ['1978年', '1984年', '1990年', '2000年'],
    answer: 2,
    explanation: '1990年党中央国务院决定开发开放上海浦东，这是我国改革开放深化的重要标志。'
  },
  {
    id: 20,
    city: '上海',
    category: 'geography',
    question: '崇明岛位于上海北部，其成因属于？',
    options: ['火山岛', '珊瑚岛', '冲积岛', '大陆岛'],
    answer: 2,
    explanation: '崇明岛是长江携带的泥沙在入海口沉积形成的冲积岛，是我国第三大岛，也是最大的河口冲积岛。'
  },
  {
    id: 21,
    city: '上海',
    category: 'geography',
    question: '下列高铁线路中起于上海的是？',
    options: ['京沪高铁', '京广高铁', '沪昆高铁', '沪深高铁'],
    answer: 0,
    explanation: '京沪高铁连接北京和上海，是我国最重要的南北高铁干线之一，起点为北京南站，终点为上海虹桥站。'
  },

  // ========== 天津 ==========
  {
    id: 22,
    city: '天津',
    category: 'geography',
    question: '天津东临的海域是？',
    options: ['渤海', '黄海', '东海', '南海'],
    answer: 0,
    explanation: '天津位于渤海湾西岸，是我国北方重要的港口城市，濒临渤海。'
  },
  {
    id: 23,
    city: '天津',
    category: 'geography',
    question: '海河在天津汇入何处？',
    options: ['渤海', '黄海', '东海', '辽东湾'],
    answer: 0,
    explanation: '海河是华北地区最大的水系，五大支流在天津汇合后注入渤海。'
  },
  {
    id: 24,
    city: '天津',
    category: 'history',
    question: '天津得名源于明永乐帝的典故，称为？',
    options: ['天子津渡', '龙兴之地', '京都门户', '北门锁钥'],
    answer: 0,
    explanation: '天津意为"天子经过的渡口"。相传明成祖朱棣靖难之役时在此渡河，赐名"天津"。'
  },
  {
    id: 26,
    city: '天津',
    category: 'history',
    question: '天津开埠通商是在哪次战争之后？',
    options: ['第一次鸦片战争', '第二次鸦片战争', '甲午战争', '八国联军侵华'],
    answer: 1,
    explanation: '第二次鸦片战争后签订的《北京条约》规定增开天津为商埠，天津正式开埠。'
  },
  {
    id: 27,
    city: '天津',
    category: 'geography',
    question: '天津位于哪条河流下游？',
    options: ['黄河', '海河', '辽河', '淮河'],
    answer: 1,
    explanation: '天津地处海河下游，是海河流域五大支流的汇合处，有"九河下梢"之称。'
  },
  {
    id: 29,
    city: '天津',
    category: 'geography',
    question: '天津与北京、河北相邻，其地理区位描述正确的是？',
    options: ['华北平原北部', '华北平原东北部', '黄土高原东缘', '内蒙古高原南缘'],
    answer: 1,
    explanation: '天津位于华北平原东北部，海河下游，东临渤海，北依燕山，地理位置优越。'
  },

  // ========== 重庆 ==========
  {
    id: 30,
    city: '重庆',
    category: 'geography',
    question: '重庆被称为"山城"，因其地形以什么为主？',
    options: ['平原', '丘陵山地', '高原', '盆地'],
    answer: 1,
    explanation: '重庆地处四川盆地东部，地形以丘陵、山地为主，城市依山而建，道路高低不平，因此被称为"山城"。'
  },
  {
    id: 31,
    city: '重庆',
    category: 'geography',
    question: '长江与哪条支流在重庆主城区交汇？',
    options: ['嘉陵江', '岷江', '沱江', '乌江'],
    answer: 0,
    explanation: '嘉陵江是长江上游重要支流，在重庆朝天门与长江交汇，形成著名的"两江交汇"景观。'
  },
  {
    id: 32,
    city: '重庆',
    category: 'geography',
    question: '重庆的气候类型是？',
    options: ['亚热带季风气候', '温带季风气候', '热带季风气候', '高原气候'],
    answer: 0,
    explanation: '重庆位于秦岭-淮河以南，属于亚热带季风气候，夏季炎热多雨，冬季温和湿润，因地形闭塞夏季特别炎热，有"火炉"之称。'
  },
  {
    id: 35,
    city: '重庆',
    category: 'history',
    question: '抗日战争时期国民政府的陪都是？',
    options: ['南京', '武汉', '重庆', '成都'],
    answer: 2,
    explanation: '抗日战争爆发后，国民政府于1937年西迁重庆，重庆成为战时陪都，是全国抗战的政治、军事中心。'
  },
  {
    id: 36,
    city: '重庆',
    category: 'history',
    question: '重庆直辖市的设立时间是？',
    options: ['1949年', '1983年', '1997年', '2000年'],
    answer: 2,
    explanation: '1997年3月，第八届全国人大五次会议批准设立重庆直辖市，这是我国最年轻的直辖市。'
  },
  {
    id: 37,
    city: '重庆',
    category: 'geography',
    question: '重庆是中国重要的工业城市之一，下列哪项是其传统优势产业？',
    options: ['丝绸纺织', '汽车摩托车制造', '葡萄酒酿造', '瓷器烧制'],
    answer: 1,
    explanation: '重庆是我国重要的汽车和摩托车生产基地，汽车摩托车制造业是重庆的传统优势支柱产业。'
  },
  {
    id: 38,
    city: '重庆',
    category: 'geography',
    question: '三峡大坝位于长江上游，工程蓄水后受回水影响最大的直辖市是？',
    options: ['北京', '上海', '天津', '重庆'],
    answer: 3,
    explanation: '三峡大坝蓄水后，回水末端到达重庆境内，重庆是受三峡工程回水影响最大的直辖市。'
  },

  // ========== 香港 ==========
  {
    id: 39,
    city: '香港',
    category: 'history',
    question: '1842年清政府割让香港岛给英国的不平等条约是？',
    options: ['《南京条约》', '《北京条约》', '《马关条约》', '《辛丑条约》'],
    answer: 0,
    explanation: '1842年鸦片战争后签订的中英《南京条约》规定割让香港岛给英国，这是近代中国第一个不平等条约。'
  },
  {
    id: 40,
    city: '香港',
    category: 'history',
    question: '英国强租九龙半岛南端是哪个条约的内容？',
    options: ['《南京条约》', '《北京条约》', '展拓香港界址专条', '《烟台条约》'],
    answer: 1,
    explanation: '1860年第二次鸦片战争后签订的《北京条约》规定割让九龙半岛南端（界限街以南）给英国。'
  },
  {
    id: 41,
    city: '香港',
    category: 'history',
    question: '新界被英国租借99年的租约始于哪一年？',
    options: ['1842年', '1860年', '1898年', '1949年'],
    answer: 2,
    explanation: '1898年中英签订《展拓香港界址专条》，英国强租新界99年，至1997年到期。'
  },
  {
    id: 42,
    city: '香港',
    category: 'history',
    question: '香港回归祖国的时间是？',
    options: ['1997年7月1日', '1999年12月20日', '1997年12月20日', '1999年7月1日'],
    answer: 0,
    explanation: '1997年7月1日，中国政府恢复对香港行使主权，香港特别行政区成立，"一国两制"正式实施。'
  },
  {
    id: 43,
    city: '香港',
    category: 'geography',
    question: '香港所处的气候类型是？',
    options: ['热带季风气候', '亚热带海洋性气候', '温带季风气候', '热带雨林气候'],
    answer: 1,
    explanation: '香港位于我国南部沿海，北回归线以南，属于亚热带海洋性气候，全年温暖湿润，夏季炎热多雨。'
  },
  {
    id: 44,
    city: '香港',
    category: 'geography',
    question: '香港特别行政区由哪三部分组成？',
    options: ['香港岛、九龙、新界', '本岛、离岛、新界', '维多利亚岛、九龙、新界', '港岛、半岛、离岛'],
    answer: 0,
    explanation: '香港由香港岛、九龙半岛和新界三部分组成，其中新界面积最大，包括大屿山等260多个岛屿。'
  },
  {
    id: 45,
    city: '香港',
    category: 'geography',
    question: '维多利亚港位于香港岛与哪个地区之间？',
    options: ['新界', '九龙半岛', '澳门', '南丫岛'],
    answer: 1,
    explanation: '维多利亚港位于香港岛与九龙半岛之间，是世界著名的天然深水良港，也是香港的标志性景观。'
  },
  {
    id: 46,
    city: '香港',
    category: 'geography',
    question: '香港是国际航运中心之一，其港口优势主要得益于？',
    options: ['水深浪静的天然深水港', '临近珠江口', '长江入海口位置', '海关便利'],
    answer: 0,
    explanation: '维多利亚港港阔水深，终年不冻，是世界三大天然良港之一，为香港成为国际航运中心提供了优越的自然条件。'
  },
  {
    id: 47,
    city: '香港',
    category: 'history',
    question: '提出"一国两制"伟大构想的国家领导人是？',
    options: ['毛泽东', '邓小平', '江泽民', '胡锦涛'],
    answer: 1,
    explanation: '"一国两制"构想是邓小平同志提出的，最初为解决台湾问题而提出，首先成功应用于解决香港、澳门问题。'
  },

  // ========== 澳门 ==========
  {
    id: 48,
    city: '澳门',
    category: 'history',
    question: '葡萄牙人借故在澳门登岸居住是在哪一年？',
    options: ['1553年', '1842年', '1624年', '1492年'],
    answer: 0,
    explanation: '1553年（明嘉靖三十二年），葡萄牙人以晾晒货物为由，贿赂明朝地方官员，获准在澳门半岛暂时居住。'
  },
  {
    id: 50,
    city: '澳门',
    category: 'history',
    question: '澳门回归祖国的时间是？',
    options: ['1997年7月1日', '1999年12月20日', '1999年7月1日', '1997年12月20日'],
    answer: 1,
    explanation: '1999年12月20日，中国政府恢复对澳门行使主权，澳门特别行政区成立，这是"一国两制"的又一成功实践。'
  },
  {
    id: 51,
    city: '澳门',
    category: 'geography',
    question: '澳门的面积主要由下列哪种方式扩展形成？',
    options: ['填海造陆', '火山喷发', '冲积平原', '山地削挖'],
    answer: 0,
    explanation: '澳门地狭人稠，百余年来通过大规模填海造陆，土地面积从最初的10多平方公里扩展至30多平方公里。'
  },
  {
    id: 52,
    city: '澳门',
    category: 'geography',
    question: '澳门的气候类型是？',
    options: ['亚热带海洋性气候', '温带季风气候', '热带雨林气候', '高原山地气候'],
    answer: 0,
    explanation: '澳门位于珠江口西岸，北回归线以南，属于亚热带海洋性气候，全年温暖湿润。'
  },
  {
    id: 53,
    city: '澳门',
    category: 'geography',
    question: '澳门最具代表性的历史名胜是？',
    options: ['大三巴牌坊', '圣保罗教堂全貌', '妈阁庙全景', '议事亭前地广场'],
    answer: 0,
    explanation: '大三巴牌坊是圣保罗教堂火灾后残存的前壁，是澳门的标志性建筑，2005年作为澳门历史城区的一部分列入世界文化遗产。'
  },
  {
    id: 54,
    city: '澳门',
    category: 'geography',
    question: '澳门经济发展的支柱产业是？',
    options: ['农业', '重工业', '博彩旅游', '渔业'],
    answer: 2,
    explanation: '博彩旅游业是澳门经济的支柱产业，澳门是世界著名的旅游休闲中心，有"东方蒙特卡洛"之称。'
  },
  {
    id: 55,
    city: '澳门',
    category: 'geography',
    question: '下列城市中与澳门陆地相连的是？',
    options: ['香港', '珠海', '深圳', '中山'],
    answer: 1,
    explanation: '澳门位于珠江口西岸，北与广东省珠海市陆地相连，东隔珠江口与香港相望。'
  },

  // ========== 台北 ==========
  {
    id: 62,
    city: '台北',
    category: 'history',
    question: '下列著名博物馆位于台北的是？',
    options: ['故宫博物院（北京）', '故宫博物院（台北）', '陕西历史博物馆', '南京博物院'],
    answer: 1,
    explanation: '台北故宫博物院收藏了大量从北京故宫南迁的文物精品，是中国重要的文物收藏机构。'
  },
  {
    id: 63,
    city: '台北',
    category: 'history',
    question: '1895年《马关条约》将台湾割让给哪个国家？',
    options: ['英国', '法国', '日本', '荷兰'],
    answer: 2,
    explanation: '1895年甲午战争后签订的《马关条约》规定割让台湾全岛及所有附属岛屿、澎湖列岛给日本，台湾开始了长达50年的日据时期。'
  },

  // ========== 广州 ==========
  {
    id: 71,
    city: '广州',
    category: 'geography',
    question: '广州所在的省级行政区是？',
    options: ['福建省', '广东省', '广西壮族自治区', '海南省'],
    answer: 1,
    explanation: '广州是广东省的省会，是华南地区的政治、经济、文化中心。'
  },
  {
    id: 72,
    city: '广州',
    category: 'geography',
    question: '广州地处下列哪条河流下游入海口附近？',
    options: ['长江', '黄河', '珠江', '钱塘江'],
    answer: 2,
    explanation: '广州位于珠江下游，濒临南海，是珠江三角洲的核心城市。'
  },
  {
    id: 73,
    city: '广州',
    category: 'geography',
    question: '广州的气候类型是？',
    options: ['亚热带季风气候', '温带季风气候', '热带季风气候', '高原气候'],
    answer: 0,
    explanation: '广州位于北回归线附近，属于亚热带季风气候，全年温暖湿润，雨季长。'
  },
  {
    id: 76,
    city: '广州',
    category: 'history',
    question: '清乾隆年间指定广州为对外通商唯一口岸的制度称为？',
    options: ['一口通商', '闭关锁国', '海禁政策', '休养生息'],
    answer: 0,
    explanation: '乾隆二十二年（1757年），清政府实行"一口通商"政策，只保留广州一处对外通商，由十三行管理对外贸易。'
  },
  {
    id: 78,
    city: '广州',
    category: 'history',
    question: '下列近代革命史迹位于广州的是？',
    options: ['武昌起义旧址', '黄花岗起义旧址', '南昌起义总指挥部', '辛亥秋瑾墓'],
    answer: 1,
    explanation: '1911年黄兴领导的黄花岗起义（广州起义）发生在广州，是辛亥革命前夕最重要的一次武装起义。'
  },
  {
    id: 79,
    city: '广州',
    category: 'geography',
    question: '广州世称"花城"，其重要的地理优势是？',
    options: ['地处长江三角洲', '地处珠江三角洲', '黄土高原腹地', '四川盆地中心'],
    answer: 1,
    explanation: '广州地处珠江三角洲，水热条件优越，四季鲜花盛开，自古有"花城"美誉。'
  },
  {
    id: 80,
    city: '广州',
    category: 'geography',
    question: '下列高铁以广州为终点的是？',
    options: ['京沪高铁', '京广高铁', '沪昆高铁', '兰新高铁'],
    answer: 1,
    explanation: '京广高铁连接北京与广州，是我国南北走向的重要高铁大动脉。'
  },

  // ========== 深圳 ==========
  {
    id: 81,
    city: '深圳',
    category: 'history',
    question: '深圳经济特区设立的时间是？',
    options: ['1979年', '1980年', '1984年', '1990年'],
    answer: 1,
    explanation: '1980年8月，全国人大常委会批准设立深圳、珠海、汕头、厦门四个经济特区，深圳是首个经济特区。'
  },
  {
    id: 82,
    city: '深圳',
    category: 'history',
    question: '撤宝安县设深圳市的时间是？',
    options: ['1978年', '1979年', '1980年', '1992年'],
    answer: 1,
    explanation: '1979年国务院批准撤销宝安县，设立深圳市，为经济特区的设立奠定了基础。'
  },
  {
    id: 83,
    city: '深圳',
    category: 'history',
    question: '被誉为"改革开放试验田"的城市是？',
    options: ['上海', '深圳', '广州', '珠海'],
    answer: 1,
    explanation: '深圳作为我国第一个经济特区，在改革开放中先行先试，创造了举世瞩目的"深圳速度"，被誉为"改革开放的试验田"。'
  },
  {
    id: 84,
    city: '深圳',
    category: 'geography',
    question: '深圳东临的海域是？',
    options: ['南海', '东海', '黄海', '渤海'],
    answer: 0,
    explanation: '深圳位于广东省南部沿海，东临大亚湾、大鹏湾，西濒珠江口，都属于南海海域。'
  },
  {
    id: 85,
    city: '深圳',
    category: 'geography',
    question: '与深圳陆地相邻的香港地区是？',
    options: ['九龙', '新界', '港岛', '离岛'],
    answer: 1,
    explanation: '深圳南隔深圳河与香港新界相邻，罗湖、福田等口岸是连接深圳与香港的重要通道。'
  },
  {
    id: 86,
    city: '深圳',
    category: 'geography',
    question: '深圳的气候类型是？',
    options: ['亚热带季风气候', '温带季风气候', '热带雨林气候', '高原气候'],
    answer: 0,
    explanation: '深圳位于北回归线以南，属于亚热带季风气候，全年温暖湿润，长夏短冬。'
  },
  {
    id: 87,
    city: '深圳',
    category: 'geography',
    question: '深圳在全国率先发展的高新技术产业门类是？',
    options: ['渔业装备', '电子通信', '钢铁冶炼', '纺织印染'],
    answer: 1,
    explanation: '深圳以电子信息产业为龙头，是我国重要的高新技术产业基地，诞生了华为、腾讯等一批知名科技企业。'
  },
  {
    id: 88,
    city: '深圳',
    category: 'geography',
    question: '连接深圳与珠海、香港的跨海大桥是？',
    options: ['杭州湾大桥', '港珠澳大桥', '青岛海湾大桥', '金塘大桥'],
    answer: 1,
    explanation: '港珠澳大桥连接香港、珠海和澳门，是世界最长的跨海大桥，2018年正式通车。'
  },

  // ========== 珠海 ==========
  {
    id: 89,
    city: '珠海',
    category: 'history',
    question: '珠海经济特区设立的时间是？',
    options: ['1979年', '1980年', '1984年', '1988年'],
    answer: 1,
    explanation: '1980年，珠海与深圳、汕头、厦门一起被设立为我国首批四个经济特区。'
  },
  {
    id: 90,
    city: '珠海',
    category: 'geography',
    question: '与珠海陆地相连的特别行政区是？',
    options: ['香港', '澳门', '台湾', '新加坡'],
    answer: 1,
    explanation: '珠海位于珠江口西岸，南与澳门陆地相接，是内地通往澳门的重要门户。'
  },
  {
    id: 91,
    city: '珠海',
    category: 'geography',
    question: '珠海面临的海域是？',
    options: ['南海', '东海', '黄海', '渤海'],
    answer: 0,
    explanation: '珠海位于广东省南部，濒临南海，有"百岛之市"的美誉。'
  },
  {
    id: 92,
    city: '珠海',
    category: 'geography',
    question: '珠海气候类型是？',
    options: ['亚热带海洋性气候', '温带季风气候', '高原气候', '热带雨林气候'],
    answer: 0,
    explanation: '珠海位于珠江口西岸，濒临南海，属于亚热带海洋性气候，全年温暖湿润，风景优美。'
  },
  {
    id: 93,
    city: '珠海',
    category: 'geography',
    question: '珠海以何种产业著称？',
    options: ['旅游会展', '钢铁冶炼', '石油化工', '瓷器烧造'],
    answer: 0,
    explanation: '珠海环境优美，是著名的宜居城市，旅游业和会展业发达，拥有珠海国际航展等知名品牌。'
  },

  // ========== 厦门 ==========
  {
    id: 100,
    city: '厦门',
    category: 'history',
    question: '明洪武年间筑厦门城的主要目的是？',
    options: ['抵御倭寇', '防范蒙古', '通商口岸', '屯田戍边'],
    answer: 0,
    explanation: '明朝初年，为抵御倭寇侵扰，在东南沿海修建了一系列卫所城池，厦门城即为其中之一。'
  },
  {
    id: 101,
    city: '厦门',
    category: 'history',
    question: '厦门五口通商之一是在哪个条约中规定？',
    options: ['《南京条约》', '《北京条约》', '《马关条约》', '《辛丑条约》'],
    answer: 0,
    explanation: '1842年《南京条约》规定开放广州、厦门、福州、宁波、上海五处为通商口岸，合称"五口通商"。'
  },
  {
    id: 102,
    city: '厦门',
    category: 'history',
    question: '厦门经济特区设立时间是？',
    options: ['1979年', '1980年', '1984年', '1988年'],
    answer: 1,
    explanation: '1980年厦门被设立为我国首批四个经济特区之一，是海峡西岸重要的中心城市。'
  },
  {
    id: 103,
    city: '厦门',
    category: 'geography',
    question: '鼓浪屿隶属的城市是？',
    options: ['福州', '厦门', '泉州', '漳州'],
    answer: 1,
    explanation: '鼓浪屿是厦门西南的一座小岛，以优美的风光和众多历史建筑闻名，有"海上花园"之称。'
  },
  {
    id: 105,
    city: '厦门',
    category: 'geography',
    question: '厦门所处的气候类型是？',
    options: ['亚热带海洋性气候', '温带季风气候', '热带季风气候', '高原气候'],
    answer: 0,
    explanation: '厦门位于福建东南沿海，属于亚热带海洋性气候，全年温暖湿润，气候宜人。'
  },
  {
    id: 106,
    city: '厦门',
    category: 'geography',
    question: '厦门所临的海峡是？',
    options: ['台湾海峡', '琼州海峡', '渤海海峡', '对马海峡'],
    answer: 0,
    explanation: '厦门位于台湾海峡西岸，与台湾岛隔海相望，是我国对台交流的重要前沿城市。'
  },

  // ========== 福州 ==========
  {
    id: 109,
    city: '福州',
    category: 'geography',
    question: '福州所在的省份简称是？',
    options: ['闽', '粤', '湘', '赣'],
    answer: 0,
    explanation: '福州是福建省省会，福建省简称"闽"，因境内有闽江而得名。'
  },
  {
    id: 110,
    city: '福州',
    category: 'geography',
    question: '福州的母亲河是？',
    options: ['闽江', '晋江', '九龙江', '汀江'],
    answer: 0,
    explanation: '闽江是福建省最大的河流，流经福州注入东海，是福州的母亲河。'
  },
  {
    id: 111,
    city: '福州',
    category: 'geography',
    question: '福州的气候类型是？',
    options: ['亚热带季风气候', '温带季风气候', '热带季风气候', '高原气候'],
    answer: 0,
    explanation: '福州位于我国东南沿海，属于亚热带季风气候，夏季高温多雨，冬季温和少雨。'
  },
  {
    id: 112,
    city: '福州',
    category: 'geography',
    question: '福州所在省份沿海特产，下列哪一项与其地理条件相关？',
    options: ['翡翠', '茶叶', '金银', '橡胶'],
    answer: 1,
    explanation: '福建多山地丘陵，气候温暖湿润，适合茶树生长，是我国重要的茶叶产区，安溪铁观音、武夷岩茶等闻名全国。'
  },
  {
    id: 114,
    city: '福州',
    category: 'history',
    question: '清代担任过福建船政大臣、创办福州船政局的是？',
    options: ['左宗棠', '李鸿章', '张之洞', '曾国藩'],
    answer: 0,
    explanation: '洋务运动时期，左宗棠在福州马尾创办福州船政局，是当时远东最大的造船厂，也是中国近代海军的摇篮。'
  },
  {
    id: 116,
    city: '福州',
    category: 'geography',
    question: '福州长乐国际机场濒临的海域是？',
    options: ['东海', '南海', '黄海', '渤海'],
    answer: 0,
    explanation: '福州位于福建东部沿海，濒临东海，是我国东南沿海重要的港口城市。'
  },

  // ========== 杭州 ==========
  {
    id: 117,
    city: '杭州',
    category: 'geography',
    question: '杭州市所在省份的简称是？',
    options: ['浙', '皖', '赣', '闽'],
    answer: 0,
    explanation: '杭州是浙江省省会，浙江省简称"浙"，因境内钱塘江（又称浙江）而得名。'
  },
  {
    id: 118,
    city: '杭州',
    category: 'geography',
    question: '杭州西湖主要由下列哪种地质作用形成？',
    options: ['火山堰塞', '潟湖演变与人工疏浚', '冰川侵蚀', '陨石坑'],
    answer: 1,
    explanation: '西湖原本是钱塘江入海口的一个潟湖，后经泥沙淤积与历代人工疏浚治理，逐渐形成闻名天下的风景名胜。'
  },
  {
    id: 119,
    city: '杭州',
    category: 'geography',
    question: '杭州的气候类型是？',
    options: ['亚热带季风气候', '温带季风气候', '高原气候', '热带季风气候'],
    answer: 0,
    explanation: '杭州位于秦岭-淮河以南，属于亚热带季风气候，四季分明，雨量充沛。'
  },
  {
    id: 120,
    city: '杭州',
    category: 'geography',
    question: '京杭大运河的南端起点城市是？',
    options: ['苏州', '杭州', '宁波', '上海'],
    answer: 1,
    explanation: '京杭大运河北起北京，南至杭州，沟通海河、黄河、淮河、长江、钱塘江五大水系，是世界最长的人工运河。'
  },
  {
    id: 123,
    city: '杭州',
    category: 'history',
    question: '五代十国时期建都于杭州的政权是？',
    options: ['南唐', '吴越', '闽', '楚'],
    answer: 1,
    explanation: '五代十国时期，钱镠建立吴越国，定都杭州，保境安民，为杭州的发展奠定了基础。'
  },
  {
    id: 124,
    city: '杭州',
    category: 'history',
    question: '南宋正式定都于临安（今杭州）的时间是？',
    options: ['1127年', '1138年', '1162年', '1276年'],
    answer: 1,
    explanation: '1138年南宋正式定都临安（今杭州），杭州成为南宋的政治、经济、文化中心，时称"行在"。'
  },
  {
    id: 126,
    city: '杭州',
    category: 'geography',
    question: '钱塘江大潮著名观潮点位于下列哪一市？',
    options: ['绍兴', '嘉兴海宁', '宁波慈溪', '舟山'],
    answer: 1,
    explanation: '钱塘江大潮是世界著名的涌潮奇观，嘉兴海宁盐官镇是最佳观潮地点。'
  },

  // ========== 宁波 ==========
  {
    id: 127,
    city: '宁波',
    category: 'geography',
    question: '宁波市濒临的海域是？',
    options: ['黄海', '东海', '南海', '渤海'],
    answer: 1,
    explanation: '宁波位于浙江东部沿海，濒临东海，是我国重要的港口城市。'
  },
  {
    id: 128,
    city: '宁波',
    category: 'geography',
    question: '舟山港位于宁波市附近，其成为世界最大港口得益于？',
    options: ['深水岸线长、避风条件好', '背靠长江三角洲', '临近首都', '邻东海深漕'],
    answer: 0,
    explanation: '宁波舟山港拥有优良的深水岸线，港阔水深，避风条件好，是世界上货物吞吐量最大的港口。'
  },
  {
    id: 131,
    city: '宁波',
    category: 'history',
    question: '"宁波"之名取自于明洪武十四年诏，意为？',
    options: ['海定则波宁', '威震东海', '远绥万里', '万世升平'],
    answer: 0,
    explanation: '宁波取"海定则波宁"之意，意为海域平静安宁，反映了沿海人民祈求平安的愿望。'
  },
  {
    id: 133,
    city: '宁波',
    category: 'geography',
    question: '"河姆渡遗址"位于宁波余姚，距今约多少年？',
    options: ['约3000年', '约5000年', '约7000年', '约9000年'],
    answer: 2,
    explanation: '河姆渡遗址距今约7000年，是我国新石器时代重要的文化遗址，发现了最早的水稻种植遗存。'
  },
  {
    id: 134,
    city: '宁波',
    category: 'geography',
    question: '宁波气候类型是？',
    options: ['亚热带季风气候', '温带季风气候', '高原气候', '热带雨林气候'],
    answer: 0,
    explanation: '宁波位于我国东南沿海，属于亚热带季风气候，四季分明，雨量充沛。'
  },
  {
    id: 135,
    city: '宁波',
    category: 'geography',
    question: '下列哪条铁路经过宁波？',
    options: ['沪昆高铁', '杭深铁路', '京沪高铁', '兰新高铁'],
    answer: 1,
    explanation: '杭深铁路（杭州至深圳）是我国东南沿海铁路大通道，经过宁波、温州、福州、厦门、汕头等沿海城市。'
  },

  // ========== 南京 ==========
  {
    id: 142,
    city: '南京',
    category: 'geography',
    question: '南京所在的地理区域是？',
    options: ['长江中下游平原', '黄土高原', '四川盆地', '云贵高原'],
    answer: 0,
    explanation: '南京位于长江下游，属于长江中下游平原，地势平坦，土壤肥沃。'
  },
  {
    id: 143,
    city: '南京',
    category: 'geography',
    question: '流经南京的最主要河流是？',
    options: ['淮河', '长江', '钱塘江', '珠江'],
    answer: 1,
    explanation: '长江穿南京城而过，南京是长江下游重要的港口城市。'
  },
  {
    id: 144,
    city: '南京',
    category: 'history',
    question: '下列朝代中曾以南京为都城的是？',
    options: ['西汉', '东汉', '三国吴', '北宋'],
    answer: 2,
    explanation: '三国时期吴国（东吴）定都建业，即今天的南京，这是南京建都之始。南京有"六朝古都"之称。'
  },
  {
    id: 145,
    city: '南京',
    category: 'history',
    question: '三国吴黄武元年最早建都南京的吴主是？',
    options: ['孙权', '孙策', '孙坚', '孙亮'],
    answer: 0,
    explanation: '公元229年，孙权称帝，定国号为吴，定都建业（今南京），史称东吴或孙吴。'
  },
  {
    id: 146,
    city: '南京',
    category: 'history',
    question: '朱元璋建立明朝后将应天府改称南京并定都的时间是？',
    options: ['1368年', '1403年', '1421年', '1644年'],
    answer: 0,
    explanation: '1368年朱元璋在应天府称帝，建立明朝，改应天府为南京，这是南京首次成为大一统王朝的都城。'
  },
  {
    id: 147,
    city: '南京',
    category: 'history',
    question: '1927年4月国民政府正式定都南京的时间点对应哪一事件之后？',
    options: ['北伐占领南京', '南昌起义', '新中国成立', '抗日战争胜利'],
    answer: 0,
    explanation: '1927年北伐军占领南京后，蒋介石在南京成立国民政府，定南京为首都。'
  },
  {
    id: 149,
    city: '南京',
    category: 'geography',
    question: '南京是下列哪条高铁的起点？',
    options: ['京沪高铁', '京广高铁', '兰新高铁', '沪昆高铁'],
    answer: 0,
    explanation: '京沪高铁连接北京和上海，南京是其中重要的枢纽站点。'
  },
  {
    id: 151,
    city: '南京',
    category: 'history',
    question: '近代史上中英《南京条约》是哪一年签订的？',
    options: ['1839年', '1842年', '1858年', '1860年'],
    answer: 1,
    explanation: '1842年8月，鸦片战争失败后，清政府在南京下关江面的英舰上签订了中国近代史上第一个不平等条约——《南京条约》。'
  },

  // ========== 无锡 ==========
  {
    id: 152,
    city: '无锡',
    category: 'geography',
    question: '无锡市所在省份的简称是？',
    options: ['苏', '浙', '皖', '沪'],
    answer: 0,
    explanation: '无锡位于江苏省南部，江苏省简称"苏"。'
  },
  {
    id: 153,
    city: '无锡',
    category: 'geography',
    question: '无锡位于下列哪条湖泊的北缘？',
    options: ['鄱阳湖', '洞庭湖', '太湖', '洪湖'],
    answer: 2,
    explanation: '无锡位于太湖北岸，是太湖流域的重要城市，有"太湖明珠"之称。'
  },
  {
    id: 155,
    city: '无锡',
    category: 'geography',
    question: '无锡气候类型是？',
    options: ['亚热带季风气候', '温带季风气候', '热带季风气候', '高原气候'],
    answer: 0,
    explanation: '无锡位于长江三角洲，属于亚热带季风气候，四季分明，雨量充沛。'
  },
  {
    id: 158,
    city: '无锡',
    category: 'geography',
    question: '无锡与下列哪座城市共同构成苏南经济带？',
    options: ['苏州、常州', '杭州、宁波', '上海、嘉兴', '南京、镇江'],
    answer: 0,
    explanation: '苏州、无锡、常州三市位于江苏南部，经济发达，构成了著名的"苏锡常"苏南经济带。'
  },

  // ========== 郑州 ==========
  {
    id: 159,
    city: '郑州',
    category: 'geography',
    question: '郑州市位于下列哪条河流中下游？',
    options: ['黄河', '淮河', '长江', '珠江'],
    answer: 0,
    explanation: '郑州位于黄河中下游交界处，黄河南岸，是河南省省会。'
  },
  {
    id: 160,
    city: '郑州',
    category: 'geography',
    question: '郑州被称为"火车拉来的省会"，主要因哪两条铁路在此交会？',
    options: ['京广、陇海', '京沪、沪昆', '京九、兰新', '焦柳、襄渝'],
    answer: 0,
    explanation: '京广铁路和陇海铁路在郑州交汇，使郑州成为我国最重要的铁路枢纽之一，城市因铁路而兴起，故有"火车拉来的城市"之说。'
  },
  {
    id: 161,
    city: '郑州',
    category: 'history',
    question: '二七大罢工发生于郑州，时间是？',
    options: ['1919年5月4日', '1923年2月7日', '1927年8月1日', '1937年7月7日'],
    answer: 1,
    explanation: '1923年2月7日，京汉铁路工人大罢工爆发，又称"二七大罢工"，是中国共产党领导的第一次工人运动高潮的顶点。'
  },
  {
    id: 164,
    city: '郑州',
    category: 'geography',
    question: '少林寺隶属郑州市登封市，位于哪一名山？',
    options: ['嵩山', '泰山', '华山', '恒山'],
    answer: 0,
    explanation: '少林寺位于嵩山少室山北麓，是中国佛教禅宗祖庭和少林武术的发源地。嵩山是五岳中的中岳。'
  },
  {
    id: 165,
    city: '郑州',
    category: 'geography',
    question: '郑州的气候类型是？',
    options: ['温带季风气候', '亚热带季风气候', '高原气候', '温带大陆性气候'],
    answer: 0,
    explanation: '郑州位于秦岭-淮河以北，属于温带季风气候，夏季高温多雨，冬季寒冷干燥。'
  },

  // ========== 武汉 ==========
  {
    id: 167,
    city: '武汉',
    category: 'geography',
    question: '武汉市由武昌、汉口、汉阳三镇组成，三镇被哪两条江河分隔？',
    options: ['长江与汉江', '长江与赣江', '赣江与汉江', '淮河与汉江'],
    answer: 0,
    explanation: '长江与汉江在武汉交汇，将武汉分为武昌、汉口、汉阳三部分，合称"武汉三镇"。'
  },
  {
    id: 168,
    city: '武汉',
    category: 'geography',
    question: '武汉被誉为"九省通衢"，主要得益于？',
    options: ['地处长江与汉江交汇，水陆枢纽位置', '临近海岸线', '毗邻京师', '边境贸易便利'],
    answer: 0,
    explanation: '武汉地处长江与汉江交汇处，位于我国中部，水陆交通便利，自古有"九省通衢"之称，是我国重要的交通枢纽。'
  },
  {
    id: 169,
    city: '武汉',
    category: 'geography',
    question: '武汉的气候类型是？',
    options: ['亚热带季风气候', '温带季风气候', '高原气候', '温带大陆性气候'],
    answer: 0,
    explanation: '武汉位于秦岭-淮河以南，属于亚热带季风气候，夏季炎热，有"火炉"之称。'
  },
  {
    id: 170,
    city: '武汉',
    category: 'history',
    question: '辛亥武昌起义打响第一枪的时间是？',
    options: ['1911年10月10日', '1912年1月1日', '1919年5月4日', '1927年8月1日'],
    answer: 0,
    explanation: '1911年10月10日，武昌起义爆发，打响了辛亥革命的第一枪，推翻了清王朝的统治，结束了中国两千多年的君主专制制度。'
  },
  {
    id: 172,
    city: '武汉',
    category: 'history',
    question: '黄鹤楼始建于三国吴，最初性质是？',
    options: ['军事瞭望楼', '观景楼', '皇宫', '道观'],
    answer: 0,
    explanation: '黄鹤楼始建于三国时期东吴黄武二年，最初是用于军事目的的瞭望楼，后逐渐成为名胜。'
  },
  {
    id: 173,
    city: '武汉',
    category: 'history',
    question: '张之洞督鄂期间在汉阳创办的中国近代钢铁企业是？',
    options: ['汉阳铁厂', '江南制造总局', '福州船政局', '开平矿务局'],
    answer: 0,
    explanation: '洋务运动时期，张之洞在汉阳创办汉阳铁厂，是中国近代最早的官办钢铁企业。'
  },

  // ========== 长沙 ==========
  {
    id: 174,
    city: '长沙',
    category: 'geography',
    question: '长沙市所在的省份简称是？',
    options: ['湘', '鄂', '赣', '黔'],
    answer: 0,
    explanation: '长沙是湖南省省会，湖南省简称"湘"，因境内有湘江而得名。'
  },
  {
    id: 175,
    city: '长沙',
    category: 'geography',
    question: '流经长沙市的主要河流是？',
    options: ['湘江', '资江', '沅江', '澧水'],
    answer: 0,
    explanation: '湘江是湖南省最大的河流，流经长沙市区，是湖南的母亲河。'
  },
  {
    id: 176,
    city: '长沙',
    category: 'geography',
    question: '长沙位于下列哪条江流域中游平原？',
    options: ['湘江下游冲积平原', '赣江平原', '鄱阳湖平原', '江汉平原'],
    answer: 0,
    explanation: '长沙位于湘江下游冲积平原，地势平坦，土壤肥沃，是湖南重要的农业区。'
  },
  {
    id: 177,
    city: '长沙',
    category: 'history',
    question: '长沙马王堆汉墓出土的不腐女尸距今约多少年？',
    options: ['约1000年', '约2200年', '约3500年', '约4500年'],
    answer: 1,
    explanation: '马王堆汉墓是西汉初期的墓葬，距今约2200年，出土了保存完好的辛追夫人遗体，震惊世界。'
  },
  {
    id: 179,
    city: '长沙',
    category: 'history',
    question: '岳麓书院始建年代属于？',
    options: ['北宋开宝年', '南宋绍兴年', '唐贞观年', '明永乐年'],
    answer: 0,
    explanation: '岳麓书院始建于北宋开宝九年（976年），是中国古代四大书院之一，历经千年，有"千年学府"之称。'
  },
  {
    id: 181,
    city: '长沙',
    category: 'geography',
    question: '橘子洲位于长沙的下列哪条江河中？',
    options: ['湘江', '浏阳河', '沩水', '捞刀河'],
    answer: 0,
    explanation: '橘子洲是湘江中的一个长岛，是长沙著名的风景名胜，毛泽东青年时期常在此游泳。'
  },
  {
    id: 182,
    city: '长沙',
    category: 'geography',
    question: '长沙气候类型是？',
    options: ['亚热带季风气候', '温带季风气候', '高原气候', '热带季风气候'],
    answer: 0,
    explanation: '长沙位于我国南方地区，属于亚热带季风气候，夏季高温多雨，冬季温和湿润。'
  },

  // ========== 南昌 ==========
  {
    id: 183,
    city: '南昌',
    category: 'geography',
    question: '南昌市所在的省份是？',
    options: ['江西省', '湖南省', '湖北省', '安徽省'],
    answer: 0,
    explanation: '南昌是江西省省会，是江西的政治、经济、文化中心。'
  },
  {
    id: 184,
    city: '南昌',
    category: 'geography',
    question: '流经南昌的主要河流是？',
    options: ['赣江', '抚河', '信江', '饶河'],
    answer: 0,
    explanation: '赣江是江西省最大的河流，流经南昌注入鄱阳湖，是江西的母亲河。'
  },
  {
    id: 185,
    city: '南昌',
    category: 'history',
    question: '南昌别名"英雄城"来源于下列哪一历史事件？',
    options: ['辛亥起义', '南昌起义', '秋收起义', '五四运动'],
    answer: 1,
    explanation: '1927年8月1日南昌起义爆发，打响了武装反抗国民党反动派的第一枪，是中国共产党独立领导武装斗争的开始，南昌因此被誉为"英雄城"。'
  },
  {
    id: 186,
    city: '南昌',
    category: 'history',
    question: '南昌起义发生于哪一年？',
    options: ['1926年', '1927年', '1928年', '1937年'],
    answer: 1,
    explanation: '1927年8月1日，周恩来、贺龙、叶挺、朱德等领导发动南昌起义，这一天后来被定为中国人民解放军建军节。'
  },
  {
    id: 188,
    city: '南昌',
    category: 'history',
    question: '滕王阁初建于唐永徽年间，得名于下列哪位封王？',
    options: ['滕王李元婴', '魏王李泰', '晋王李治', '越王李贞'],
    answer: 0,
    explanation: '滕王阁由唐高祖李渊之子滕王李元婴任洪州都督时所建，因此得名。因王勃《滕王阁序》而名扬天下。'
  },
  {
    id: 190,
    city: '南昌',
    category: 'geography',
    question: '南昌气候类型是？',
    options: ['亚热带季风气候', '温带季风气候', '热带季风气候', '高原气候'],
    answer: 0,
    explanation: '南昌位于我国南方地区，属于亚热带季风气候，夏季炎热，是长江流域"火炉"城市之一。'
  },

  // ========== 合肥 ==========
  {
    id: 192,
    city: '合肥',
    category: 'geography',
    question: '合肥市是哪一省的省会？',
    options: ['安徽省', '江苏省', '浙江省', '江西省'],
    answer: 0,
    explanation: '合肥是安徽省省会，是安徽省的政治、经济、文化中心。'
  },
  {
    id: 194,
    city: '合肥',
    category: 'history',
    question: '三国时期合肥因李典、张辽守城抗吴而闻名，此战役是？',
    options: ['合肥之战（逍遥津）', '赤壁之战', '官渡之战', '夷陵之战'],
    answer: 0,
    explanation: '三国时期魏吴在合肥多次交战，其中逍遥津之战张辽以少胜多大败吴军，是历史上著名的以少胜多战役。'
  },
  {
    id: 197,
    city: '合肥',
    category: 'geography',
    question: '中国科学技术大学主校区所在城市是？',
    options: ['北京', '上海', '合肥', '武汉'],
    answer: 2,
    explanation: '中国科学技术大学1958年创办于北京，1970年迁至合肥，是合肥成为全国重要科教基地的重要基础。'
  },
  {
    id: 198,
    city: '合肥',
    category: 'geography',
    question: '合肥气候类型是？',
    options: ['亚热带季风气候', '温带季风气候', '温带大陆性气候', '高原气候'],
    answer: 0,
    explanation: '合肥位于秦岭-淮河以南，属于亚热带季风气候，四季分明，气候温和。'
  },
  {
    id: 199,
    city: '合肥',
    category: 'history',
    question: '北宋名臣、被尊"包孝肃公"，出生于合肥的名人是？',
    options: ['包拯', '范仲淹', '寇准', '文天祥'],
    answer: 0,
    explanation: '包拯是北宋著名清官，庐州合肥（今安徽合肥）人，为官清廉，被百姓尊称为"包公"。'
  },
  {
    id: 201,
    city: '合肥',
    category: 'geography',
    question: '合肥位于下列哪条重要地理分界线附近？',
    options: ['江淮分水岭', '大兴安岭-太行山', '秦岭-淮河', '巫山-雪峰山'],
    answer: 0,
    explanation: '合肥地处江淮之间，位于江淮分水岭附近，是长江流域与淮河流域的过渡地带。'
  },

  // ========== 沈阳 ==========
  {
    id: 202,
    city: '沈阳',
    category: 'geography',
    question: '沈阳市所在的省份简称是？',
    options: ['辽', '黑', '吉', '蒙'],
    answer: 0,
    explanation: '沈阳是辽宁省省会，辽宁省简称"辽"。'
  },
  {
    id: 203,
    city: '沈阳',
    category: 'geography',
    question: '沈阳位于哪一大河流域？',
    options: ['辽河流域', '松花江流域', '海河流域', '黑龙江流域'],
    answer: 0,
    explanation: '沈阳位于辽河平原中部，属于辽河流域，是东北地区重要的中心城市。'
  },
  {
    id: 204,
    city: '沈阳',
    category: 'geography',
    question: '沈阳气候类型是？',
    options: ['温带季风气候', '亚热带季风气候', '温带大陆性气候', '高原气候'],
    answer: 0,
    explanation: '沈阳位于我国东北地区，属于温带季风气候，冬季寒冷漫长，夏季温暖短促。'
  },
  {
    id: 205,
    city: '沈阳',
    category: 'history',
    question: '1625年清太祖将后金都城迁至沈阳，此君主是？',
    options: ['努尔哈赤', '皇太极', '福临', '玄烨'],
    answer: 0,
    explanation: '1625年，后金大汗努尔哈赤将都城从辽阳迁至沈阳，沈阳从此成为清朝入关前的统治中心。'
  },
  {
    id: 206,
    city: '沈阳',
    category: 'history',
    question: '清朝定鼎北京前沈阳作为都城又称？',
    options: ['盛京', '京师', '奉天府治', '辽阳'],
    answer: 0,
    explanation: '1634年皇太极改沈阳为盛京，1644年清军入关定都北京后，盛京成为留都。'
  },
  {
    id: 207,
    city: '沈阳',
    category: 'history',
    question: '下列哪处皇宫建筑是清初皇宫？',
    options: ['沈阳故宫', '北京故宫', '避暑山庄', '台北故宫'],
    answer: 0,
    explanation: '沈阳故宫是清朝入关前努尔哈赤、皇太极时期建造的皇宫，是我国仅存的两大古代宫殿建筑群之一。'
  },
  {
    id: 208,
    city: '沈阳',
    category: 'history',
    question: '九一八事变发生的城市是？',
    options: ['沈阳', '北京', '上海', '武汉'],
    answer: 0,
    explanation: '1931年9月18日，日本关东军在沈阳制造柳条湖事件，发动九一八事变，这是日本侵华战争的开端。'
  },
  {
    id: 209,
    city: '沈阳',
    category: 'history',
    question: '九一八事变发生时间是？',
    options: ['1931年9月18日', '1937年7月7日', '1937年12月13日', '1945年8月15日'],
    answer: 0,
    explanation: '1931年9月18日夜，日本关东军制造九一八事变，悍然进攻中国东北军驻地北大营，进而侵占整个东北。'
  },
  {
    id: 210,
    city: '沈阳',
    category: 'geography',
    question: '沈阳工业以哪一类产业著称？',
    options: ['装备制造、重工业', '葡萄酒酿造', '丝绸纺织', '陶瓷烧制'],
    answer: 0,
    explanation: '沈阳是我国重要的老工业基地，以装备制造业为核心的重工业发达，被誉为"共和国装备部"。'
  },

  // ========== 大连 ==========
  {
    id: 211,
    city: '大连',
    category: 'geography',
    question: '大连市位于辽东半岛南端，三面环绕的海域是？',
    options: ['渤海与黄海', '黄海与东海', '东海与南海', '渤海与南海'],
    answer: 0,
    explanation: '大连位于辽东半岛最南端，东濒黄海，西临渤海，是我国北方重要的港口和旅游城市。'
  },
  {
    id: 212,
    city: '大连',
    category: 'geography',
    question: '大连气候类型是？',
    options: ['温带季风气候', '热带季风气候', '高原气候', '沙漠气候'],
    answer: 0,
    explanation: '大连位于辽东半岛南端，属于温带季风气候，但受海洋影响显著，冬暖夏凉，气候宜人。'
  },
  {
    id: 214,
    city: '大连',
    category: 'history',
    question: '1905年日俄战争后取代沙俄占据大连的国家是？',
    options: ['英国', '日本', '法国', '美国'],
    answer: 1,
    explanation: '1904-1905年日俄战争后，日本从俄国手中夺取了大连和旅顺的租借权，开始了对大连长达40年的殖民统治。'
  },
  {
    id: 216,
    city: '大连',
    category: 'geography',
    question: '大连港成为中国北方最重要港口之一，主要优势是？',
    options: ['终年不冻的深水良港', '河口三角洲位置', '毗邻首都', '海上距离欧洲最近'],
    answer: 0,
    explanation: '大连港港阔水深，冬季不冻，是我国北方最重要的天然深水良港之一，也是东北地区的海上门户。'
  },

  // ========== 青岛 ==========
  {
    id: 218,
    city: '青岛',
    category: 'geography',
    question: '青岛市所在省份简称是？',
    options: ['鲁', '苏', '皖', '冀'],
    answer: 0,
    explanation: '青岛位于山东省南部沿海，山东省简称"鲁"。'
  },
  {
    id: 219,
    city: '青岛',
    category: 'geography',
    question: '青岛所临的海域是？',
    options: ['黄海', '东海', '渤海', '南海'],
    answer: 0,
    explanation: '青岛位于山东半岛南部，濒临黄海，是我国北方重要的港口城市和滨海旅游城市。'
  },
  {
    id: 220,
    city: '青岛',
    category: 'geography',
    question: '青岛所在半岛是？',
    options: ['山东半岛', '辽东半岛', '雷州半岛', '舟山半岛'],
    answer: 0,
    explanation: '青岛位于山东半岛南部沿海，山东半岛是我国最大的半岛。'
  },
  {
    id: 222,
    city: '青岛',
    category: 'history',
    question: '1897年德国借口巨野教案强占的港湾是？',
    options: ['胶州湾', '大连湾', '杭州湾', '北部湾'],
    answer: 0,
    explanation: '1897年德国借口巨野教案，派军舰强占胶州湾，次年强迫清政府签订《胶澳租借条约》，租借胶州湾99年。'
  },
  {
    id: 223,
    city: '青岛',
    category: 'history',
    question: '1914年取代德国占据青岛的国家是？',
    options: ['英国', '日本', '法国', '俄国'],
    answer: 1,
    explanation: '第一次世界大战期间，日本对德宣战，于1914年出兵占领了德国租借的胶州湾和青岛。'
  },
  {
    id: 224,
    city: '青岛',
    category: 'history',
    question: '1922年青岛主权收回与下列哪一场会议直接相关？',
    options: ['华盛顿会议', '巴黎和会', '雅尔塔会议', '波茨坦会议'],
    answer: 0,
    explanation: '1921-1922年华盛顿会议期间，中日签订《解决山东悬案条约》，1922年中国正式收回青岛主权。'
  },
  {
    id: 226,
    city: '青岛',
    category: 'geography',
    question: '青岛气候类型以温和湿润著称，其气候类型是？',
    options: ['温带季风气候', '亚热带季风气候', '热带海洋性气候', '高原气候'],
    answer: 0,
    explanation: '青岛属于温带季风气候，但受海洋调节作用明显，冬无严寒，夏无酷暑，气候宜人，是著名的避暑胜地。'
  },
  {
    id: 228,
    city: '青岛',
    category: 'geography',
    question: '下列哪条高铁终到青岛？',
    options: ['济青高铁', '京沪高铁', '沪昆高铁', '兰新高铁'],
    answer: 0,
    explanation: '济青高铁连接济南和青岛，是山东省内重要的高铁干线。'
  },

  // ========== 济南 ==========
  {
    id: 229,
    city: '济南',
    category: 'geography',
    question: '济南是哪一省省会？',
    options: ['山东省', '河北省', '山西省', '河南省'],
    answer: 0,
    explanation: '济南是山东省省会，因地处古济水之南而得名。'
  },
  {
    id: 230,
    city: '济南',
    category: 'geography',
    question: '济南被誉为"泉城"，下列哪一泉被誉为"天下第一泉"？',
    options: ['趵突泉', '黑虎泉', '珍珠泉', '五龙潭'],
    answer: 0,
    explanation: '趵突泉是济南七十二名泉之首，被誉为"天下第一泉"，是济南的标志性景观。'
  },
  {
    id: 231,
    city: '济南',
    category: 'geography',
    question: '济南所在的河流流域主要为？',
    options: ['黄河流域', '长江流域', '淮河流域', '海河流域'],
    answer: 0,
    explanation: '济南位于黄河下游南岸，属于黄河流域，黄河在济南北部穿城而过。'
  },
  {
    id: 232,
    city: '济南',
    category: 'geography',
    question: '济南气候类型是？',
    options: ['温带季风气候', '亚热带季风气候', '高原气候', '热带季风气候'],
    answer: 0,
    explanation: '济南位于我国北方地区，属于温带季风气候，四季分明，夏季炎热多雨。'
  },
  {
    id: 235,
    city: '济南',
    category: 'history',
    question: '下列哪位著名女词人是济南人？',
    options: ['李清照', '朱淑真', '蔡文姬', '上官婉儿'],
    answer: 0,
    explanation: '李清照是宋代著名女词人，号易安居士，济南章丘人，是婉约词派的代表人物。'
  },
  {
    id: 236,
    city: '济南',
    category: 'geography',
    question: '大明湖位于济南老城北部，其湖水主要由下列哪种水源补给？',
    options: ['泉水汇流', '冰川融水', '海潮顶托', '雨水蓄积'],
    answer: 0,
    explanation: '大明湖由济南众多泉水汇流而成，湖水清澈，有"众泉汇流成大明湖"之说，是济南三大名胜之一。'
  },
  {
    id: 237,
    city: '济南',
    category: 'history',
    question: '济南惨案即五三惨案发生的时间是？',
    options: ['1926年', '1928年', '1937年', '1945年'],
    answer: 1,
    explanation: '1928年5月3日，日本侵略者在济南制造了骇人听闻的济南惨案（又称五三惨案），屠杀中国军民数千人。'
  },
  {
    id: 238,
    city: '济南',
    category: 'geography',
    question: '济南千佛山地处下列哪一名山余脉？',
    options: ['泰山余脉', '华山余脉', '嵩山余脉', '太行山余脉'],
    answer: 0,
    explanation: '千佛山位于济南南部，是泰山余脉，因山上佛像众多而得名，是济南三大名胜之一。'
  },
  {
    id: 239,
    city: '济南',
    category: 'geography',
    question: '济南是京沪高铁沿线重要节点，其下列相邻站点是？',
    options: ['德州东、泰安', '南京南、苏州北', '郑州东、武汉', '长沙南、衡阳东'],
    answer: 0,
    explanation: '京沪高铁在山东境内自北向南经过德州、济南、泰安等站点，济南是其中最重要的枢纽。'
  },

  // ========== 烟台 ==========
  {
    id: 241,
    city: '烟台',
    category: 'history',
    question: '明洪武三十一年在烟台设奇山守御千户所的主要目的是？',
    options: ['防倭寇', '抗蒙', '通商', '屯田'],
    answer: 0,
    explanation: '明朝初年，为抵御倭寇侵扰，在山东沿海设立了一系列卫所，奇山守御千户所即为其中之一。'
  },
  {
    id: 245,
    city: '烟台',
    category: 'history',
    question: '"烟台"之名来源于下列哪种设施？',
    options: ['烽火台狼烟墩', '盐场烟囱', '烽火驿站', '灯塔'],
    answer: 0,
    explanation: '烟台因明代在烟台山设置狼烟墩台（烽火台）以防倭寇而得名，意为"狼烟升起的台子"。'
  },
  {
    id: 246,
    city: '烟台',
    category: 'geography',
    question: '烟台市地处哪两海交汇处？',
    options: ['渤海与黄海', '黄海与东海', '东海与南海', '渤海与南海'],
    answer: 0,
    explanation: '烟台位于山东半岛北部，濒临渤海和黄海，蓬莱是黄渤海分界线的标志性地点。'
  },
  {
    id: 247,
    city: '烟台',
    category: 'geography',
    question: '烟台所在的半岛是？',
    options: ['山东半岛', '辽东半岛', '雷州半岛', '舟山半岛'],
    answer: 0,
    explanation: '烟台位于山东半岛北部沿海，是山东半岛重要的港口城市。'
  },
  {
    id: 248,
    city: '烟台',
    category: 'geography',
    question: '烟台气候类型是？',
    options: ['温带季风气候', '亚热带季风气候', '热带季风气候', '高原气候'],
    answer: 0,
    explanation: '烟台位于山东半岛北部，属于温带季风气候，受海洋影响，气候温和，是著名的滨海旅游城市。'
  },
  {
    id: 249,
    city: '烟台',
    category: 'geography',
    question: '蓬莱阁所在区隶属于哪一地级市？',
    options: ['青岛市', '烟台市', '威海市', '潍坊市'],
    answer: 1,
    explanation: '蓬莱阁位于烟台市蓬莱区，是中国四大名楼之一，以"八仙过海"传说和海市蜃楼奇观闻名。'
  },
  {
    id: 251,
    city: '烟台',
    category: 'geography',
    question: '烟台是中国下列哪种水果的著名产区？',
    options: ['苹果', '椰子', '芒果', '荔枝'],
    answer: 0,
    explanation: '烟台是我国著名的苹果产区，烟台苹果以果形端正、色泽艳丽、口感甜脆闻名全国。'
  },

  // ========== 石家庄 ==========
  {
    id: 256,
    city: '石家庄',
    category: 'history',
    question: '中共七届二中全会召开地位于石家庄平山县，此地名是？',
    options: ['西柏坡', '南泥湾', '枣园', '杨家岭'],
    answer: 0,
    explanation: '1949年3月，中共七届二中全会在河北省平山县西柏坡召开，这是解放战争时期党中央最后一次在农村召开的重要会议。'
  },
  {
    id: 257,
    city: '石家庄',
    category: 'geography',
    question: '石家庄位于哪一地形区西缘？',
    options: ['华北平原与太行山东麓', '黄土高原东缘', '内蒙古高原南缘', '辽东丘陵'],
    answer: 0,
    explanation: '石家庄位于华北平原西部，太行山东麓，是京广铁路沿线的重要城市。'
  },
  {
    id: 258,
    city: '石家庄',
    category: 'geography',
    question: '穿越石家庄市境的主要河流是？',
    options: ['滹沱河', '漳河', '汾河', '渭河'],
    answer: 0,
    explanation: '滹沱河是海河水系子牙河的支流，流经石家庄市区，是石家庄的母亲河。'
  },
  {
    id: 259,
    city: '石家庄',
    category: 'geography',
    question: '石家庄气候类型是？',
    options: ['温带季风气候', '亚热带季风气候', '高原气候', '热带季风气候'],
    answer: 0,
    explanation: '石家庄位于我国北方地区，属于温带季风气候，四季分明，夏季高温多雨，冬季寒冷干燥。'
  },
  {
    id: 260,
    city: '石家庄',
    category: 'geography',
    question: '石家庄是哪两条铁路交会枢纽？',
    options: ['京广与石太', '京沪与陇海', '京九与兰新', '焦柳与襄渝'],
    answer: 0,
    explanation: '京广铁路和石太（石家庄-太原）铁路在石家庄交汇，使石家庄成为重要的铁路枢纽城市。'
  },
  {
    id: 262,
    city: '石家庄',
    category: 'geography',
    question: '赵州桥位于石家庄赵县，其建造者是？',
    options: ['李春', '鲁班', '李冰', '宇文恺'],
    answer: 0,
    explanation: '赵州桥（安济桥）由隋代工匠李春设计建造，是世界上现存最古老的敞肩石拱桥，距今已有1400多年历史。'
  },

  // ========== 太原 ==========
  {
    id: 264,
    city: '太原',
    category: 'history',
    question: '秦庄襄王二年在今太原地区置的郡名是？',
    options: ['太原郡', '上党郡', '河东郡', '雁门郡'],
    answer: 0,
    explanation: '秦庄襄王二年（公元前248年）设置太原郡，"太原"意为"大平原"，这是太原作为行政区划名称之始。'
  },
  {
    id: 267,
    city: '太原',
    category: 'history',
    question: '1949年4月24日太原解放后成为哪一省省会？',
    options: ['山西省', '陕西省', '河北省', '河南省'],
    answer: 0,
    explanation: '太原是山西省省会，是山西的政治、经济、文化中心，有"龙城"之称。'
  },
  {
    id: 268,
    city: '太原',
    category: 'geography',
    question: '太原市被哪条黄河支流穿城而过？',
    options: ['汾河', '渭河', '沁河', '泾河'],
    answer: 0,
    explanation: '汾河是黄河第二大支流，自北向南穿太原市区而过，是山西的母亲河。'
  },
  {
    id: 269,
    city: '太原',
    category: 'geography',
    question: '太原所在的地形区是？',
    options: ['太原盆地', '汾河谷地', '关中平原', '上党盆地'],
    answer: 0,
    explanation: '太原位于太原盆地北部，东西两面环山，汾河穿城而过，是汾河谷地中的重要城市。'
  },
  {
    id: 270,
    city: '太原',
    category: 'geography',
    question: '太原气候类型是？',
    options: ['温带季风气候', '亚热带季风气候', '温带大陆性气候', '高原气候'],
    answer: 0,
    explanation: '太原位于我国北方地区，属于温带季风气候，因地处内陆，大陆性特征较明显，昼夜温差较大。'
  },
  {
    id: 273,
    city: '太原',
    category: 'geography',
    question: '太原所在地理分区属于？',
    options: ['黄土高原', '华北平原', '内蒙古高原', '青藏高原'],
    answer: 0,
    explanation: '太原位于山西省中部，从自然地理分区来看，属于黄土高原东部边缘地带。'
  },

  // ========== 呼和浩特 ==========
  {
    id: 278,
    city: '呼和浩特',
    category: 'geography',
    question: '呼和浩特是哪一自治区首府？',
    options: ['内蒙古自治区', '新疆维吾尔自治区', '宁夏回族自治区', '广西壮族自治区'],
    answer: 0,
    explanation: '呼和浩特是内蒙古自治区首府，是内蒙古的政治、经济、文化中心。'
  },
  {
    id: 279,
    city: '呼和浩特',
    category: 'geography',
    question: '呼和浩特北靠下列哪条山脉？',
    options: ['阴山大青山', '秦岭', '天山', '祁连山'],
    answer: 0,
    explanation: '呼和浩特北靠阴山山脉的大青山，南濒黄河，位于河套平原东部。'
  },
  {
    id: 280,
    city: '呼和浩特',
    category: 'geography',
    question: '呼和浩特所在的流域是？',
    options: ['黄河流域', '辽河流域', '海河流域', '内陆河流域'],
    answer: 0,
    explanation: '呼和浩特位于黄河支流大黑河沿岸，属于黄河流域。'
  },
  {
    id: 281,
    city: '呼和浩特',
    category: 'geography',
    question: '呼和浩特气候类型是？',
    options: ['温带大陆性气候', '温带季风气候', '亚热带季风气候', '高原气候'],
    answer: 0,
    explanation: '呼和浩特位于内蒙古高原，属于温带大陆性气候，冬长夏短，降水较少，昼夜温差大。'
  },
  {
    id: 282,
    city: '呼和浩特',
    category: 'geography',
    question: '大昭寺位于呼和浩特旧城，是哪种宗教寺院？',
    options: ['藏传佛教', '汉传佛教', '伊斯兰教', '道教'],
    answer: 0,
    explanation: '大昭寺（无量寺）是呼和浩特最早的藏传佛教寺院，建于明代，是内蒙古地区重要的藏传佛教圣地。'
  },

  // ========== 西安 ==========
  {
    id: 301,
    city: '西安',
    category: 'history',
    question: '西周都城镐京位于今西安附近，营建者相传是？',
    options: ['周文王周武王', '周公旦', '周成王', '周幽王'],
    answer: 0,
    explanation: '周文王迁都丰京，周武王营建镐京，合称丰镐，是西周的都城，位于今西安长安区附近。'
  },
  {
    id: 302,
    city: '西安',
    category: 'history',
    question: '秦都咸阳位于今西安附近哪条河之畔？',
    options: ['渭河', '泾河', '洛河', '汾河'],
    answer: 0,
    explanation: '秦都咸阳位于渭河北岸，与后来的汉长安城隔渭河相望，都在今西安市周边。'
  },
  {
    id: 303,
    city: '西安',
    category: 'history',
    question: '汉高祖五年置长安县，"长安"意指？',
    options: ['长治久安', '长久平安', '长河平原', '长生不老'],
    answer: 0,
    explanation: '汉高祖五年设置长安县，取"长治久安"之意，后在此建都，称长安城。'
  },
  {
    id: 304,
    city: '西安',
    category: 'history',
    question: '唐天宝年间长安人口过百万为当时世界最大城市，"天宝"是哪位皇帝年号？',
    options: ['唐玄宗', '唐太宗', '唐高宗', '唐肃宗'],
    answer: 0,
    explanation: '"天宝"是唐玄宗李隆基的年号，天宝年间唐朝达到鼎盛，史称"开元盛世"的延续，长安城是当时世界上最大的城市。'
  },
  {
    id: 305,
    city: '西安',
    category: 'history',
    question: '西安被誉为"十三朝古都"，下列哪个朝代不以西安为都？',
    options: ['西晋', '西汉', '唐', '隋'],
    answer: 0,
    explanation: '西晋都城在洛阳。西安是十三朝古都，西周、秦、西汉、隋、唐等重要朝代都在此建都。'
  },
  {
    id: 306,
    city: '西安',
    category: 'history',
    question: '明洪武七年建西安城，原唐皇城基础上重筑，"洪武"是？',
    options: ['朱元璋年号', '朱棣年号', '朱允炆年号', '朱由检年号'],
    answer: 0,
    explanation: '"洪武"是明太祖朱元璋的年号，明代西安城墙就是在洪武年间扩建而成的，是我国现存最完整的古代城垣之一。'
  },
  {
    id: 307,
    city: '西安',
    category: 'history',
    question: '1936年12月12日西安事变发动者是？',
    options: ['张学良、杨虎城', '蒋介石', '汪精卫', '李宗仁'],
    answer: 0,
    explanation: '1936年12月12日，张学良、杨虎城在西安扣押蒋介石，发动西安事变，逼蒋抗日，最终促成了抗日民族统一战线的初步形成。'
  },
  {
    id: 310,
    city: '西安',
    category: 'geography',
    question: '西安位于下列哪个地形区中心？',
    options: ['渭河平原', '汉江平原', '汾河平原', '河套平原'],
    answer: 0,
    explanation: '西安位于渭河平原（关中平原）中部，这里土壤肥沃，灌溉便利，自古有"八百里秦川"之称。'
  },
  {
    id: 311,
    city: '西安',
    category: 'geography',
    question: '西安南界是哪条山脉？',
    options: ['秦岭', '大巴山', '六盘山', '贺兰山'],
    answer: 0,
    explanation: '西安南依秦岭，秦岭是我国南方与北方的重要地理分界线，也是黄河流域与长江流域的分水岭。'
  },
  {
    id: 312,
    city: '西安',
    category: 'geography',
    question: '西安所在的渭河平原又称？',
    options: ['关中平原', '汉中平原', '陇东高原', '陇中高原'],
    answer: 0,
    explanation: '渭河平原又称关中平原或关中盆地，西起宝鸡，东至潼关，东西长约300公里，号称"八百里秦川"。'
  },
  {
    id: 313,
    city: '西安',
    category: 'geography',
    question: '西安气候类型是？',
    options: ['温带季风气候', '亚热带季风气候', '温带大陆性气候', '高原气候'],
    answer: 0,
    explanation: '西安位于秦岭以北，属于温带季风气候，四季分明，降水集中在夏季。'
  },
  {
    id: 314,
    city: '西安',
    category: 'geography',
    question: '大雁塔位于大慈恩寺，最初用途是？',
    options: ['玄奘藏经塔', '天文观测', '军事瞭望', '皇宫附属'],
    answer: 0,
    explanation: '大雁塔建于唐代，是玄奘法师为保存从印度带回的经卷佛像而主持修建的藏经塔，是西安的标志性建筑。'
  },
  {
    id: 317,
    city: '西安',
    category: 'history',
    question: '西汉张骞通西域的出发都城是？',
    options: ['长安', '洛阳', '邺城', '建康'],
    answer: 0,
    explanation: '西汉都城在长安（今西安），张骞从长安出发出使西域，开辟了著名的丝绸之路。'
  },
  {
    id: 318,
    city: '西安',
    category: 'history',
    question: '唐僧玄奘西行取经的出发地是？',
    options: ['长安', '洛阳', '金陵', '邺'],
    answer: 0,
    explanation: '唐代高僧玄奘从长安（今西安）出发，西行天竺（今印度）取经，历时十余年返回长安。'
  },

  // ========== 兰州 ==========
  {
    id: 323,
    city: '兰州',
    category: 'geography',
    question: '唯一被黄河穿过的省会城市是？',
    options: ['兰州', '银川', '郑州', '济南'],
    answer: 0,
    explanation: '兰州是唯一一座黄河穿城而过的省会城市，黄河自西向东横贯市区，形成了独特的滨河城市景观。'
  },
  {
    id: 324,
    city: '兰州',
    category: 'geography',
    question: '兰州地处下列哪个高原东北缘？',
    options: ['青藏高原', '内蒙古高原', '黄土高原', '云贵高原'],
    answer: 0,
    explanation: '兰州位于青藏高原东北缘，黄土高原西部，是黄土高原与青藏高原的过渡地带。'
  },
  {
    id: 325,
    city: '兰州',
    category: 'geography',
    question: '兰州气候类型是？',
    options: ['温带半干旱气候', '温带季风气候', '亚热带季风气候', '高原气候'],
    answer: 0,
    explanation: '兰州地处内陆，降水较少，属于温带半干旱大陆性气候，昼夜温差大，日照充足。'
  },
  {
    id: 326,
    city: '兰州',
    category: 'geography',
    question: '兰州在古代丝绸之路上的地位是？',
    options: ['河西走廊东端重镇', '草原丝路终点', '海上丝路起点', '南方丝路起点'],
    answer: 0,
    explanation: '兰州位于河西走廊东端，是古丝绸之路上的重镇，也是中原通往西域的交通要冲。'
  },
  {
    id: 329,
    city: '兰州',
    category: 'geography',
    question: '中山桥是黄河上最早铁桥，建于哪一年？',
    options: ['1907年', '1912年', '1925年', '1949年'],
    answer: 0,
    explanation: '兰州中山桥建于1907年（清光绪三十三年），是黄河上第一座永久性铁桥，有"天下黄河第一桥"之称。'
  },
  {
    id: 330,
    city: '兰州',
    category: 'geography',
    question: '兰州市境内黄河最大支流之一是？',
    options: ['大通河', '洮河', '渭河', '汾河'],
    answer: 1,
    explanation: '洮河是黄河上游重要支流，在兰州附近汇入黄河，是黄河上游水量较大的支流之一。'
  },

  // ========== 西宁 ==========
  {
    id: 333,
    city: '西宁',
    category: 'history',
    question: '1929年青海建省，省会定为西宁，此前西宁隶属哪一省？',
    options: ['甘肃省', '陕西省', '宁夏省', '新疆省'],
    answer: 0,
    explanation: '1929年青海建省之前，西宁地区一直隶属于甘肃省。青海建省后，西宁成为青海省省会。'
  },
  {
    id: 335,
    city: '西宁',
    category: 'geography',
    question: '西宁地处下列哪个河谷？',
    options: ['湟水谷地', '汾河谷地', '渭河谷地', '洮河谷地'],
    answer: 0,
    explanation: '西宁位于湟水谷地，湟水是黄河上游重要支流，湟水谷地是青海省最重要的农业区。'
  },
  {
    id: 336,
    city: '西宁',
    category: 'geography',
    question: '西宁被誉为下列哪种门户？',
    options: ['青藏高原东方门户', '新疆东方门户', '河西走廊西大门', '蒙古高原南门'],
    answer: 0,
    explanation: '西宁位于青藏高原东部，是进入青藏高原的东方门户，自古就是西北交通要道和军事重镇。'
  },
  {
    id: 337,
    city: '西宁',
    category: 'geography',
    question: '西宁气候类型是？',
    options: ['高原大陆性气候', '温带季风气候', '亚热带季风气候', '热带季风气候'],
    answer: 0,
    explanation: '西宁海拔约2200米，属于高原大陆性气候，夏季凉爽宜人，有"中国夏都"之称。'
  },
  {
    id: 340,
    city: '西宁',
    category: 'geography',
    question: '西宁是下列哪条河流上游重要城市？',
    options: ['黄河支流湟水', '长江上游通天河', '澜沧江', '雅鲁藏布江'],
    answer: 0,
    explanation: '西宁位于湟水河畔，湟水是黄河上游的重要支流，孕育了河湟文化。'
  },

  // ========== 乌鲁木齐 ==========
  {
    id: 341,
    city: '乌鲁木齐',
    category: 'history',
    question: '元代"乌鲁木齐"蒙古语意为？',
    options: ['优美的牧场', '金色的山', '青色的城', '黑河'],
    answer: 0,
    explanation: '"乌鲁木齐"在蒙古语中意为"优美的牧场"，反映了这里历史上曾是水草丰美的游牧之地。'
  },
  {
    id: 342,
    city: '乌鲁木齐',
    category: 'history',
    question: '清乾隆二十年筑城，乾隆二十八年赐名是？',
    options: ['迪化', '绥远', '归绥', '库伦'],
    answer: 0,
    explanation: '清乾隆二十八年（1763年），乾隆皇帝赐名"迪化"，意为"开导教化"。1954年恢复乌鲁木齐原名。'
  },
  {
    id: 343,
    city: '乌鲁木齐',
    category: 'history',
    question: '1954年恢复乌鲁木齐原名，"迪化"之名的本意被批评为？',
    options: ['启发教化他族', '安定边疆', '开发西域', '通商便利'],
    answer: 0,
    explanation: '"迪化"有"启迪教化"少数民族之意，带有民族歧视色彩，因此1954年恢复了乌鲁木齐的原名。'
  },
  {
    id: 344,
    city: '乌鲁木齐',
    category: 'history',
    question: '1884年新疆建省后定为省会，主持建省的钦差大臣是？',
    options: ['左宗棠', '林则徐', '曾国藩', '李鸿章'],
    answer: 0,
    explanation: '左宗棠率军收复新疆后，力主新疆建省。1884年清政府正式设立新疆省，省会定在迪化（今乌鲁木齐）。'
  },
  {
    id: 345,
    city: '乌鲁木齐',
    category: 'geography',
    question: '乌鲁木齐是世界上哪一类典型城市？',
    options: ['距海最远的大城市', '海拔最高的城市', '最北端城市', '面积最大城市'],
    answer: 0,
    explanation: '乌鲁木齐深居亚欧大陆内部，距海约2500公里，是世界上距离海洋最远的大城市。'
  },
  {
    id: 347,
    city: '乌鲁木齐',
    category: 'geography',
    question: '乌鲁木齐南靠下列哪条山脉？',
    options: ['天山', '阿尔泰山', '昆仑山', '祁连山'],
    answer: 0,
    explanation: '乌鲁木齐位于天山北麓，准噶尔盆地南缘，天山山脉是新疆重要的地理分界线。'
  },
  {
    id: 348,
    city: '乌鲁木齐',
    category: 'geography',
    question: '乌鲁木齐气候类型是？',
    options: ['温带大陆性气候', '温带季风气候', '高原气候', '亚热带季风气候'],
    answer: 0,
    explanation: '乌鲁木齐深居内陆，远离海洋，属于典型的温带大陆性气候，冬冷夏热，降水稀少，昼夜温差大。'
  },
  {
    id: 352,
    city: '乌鲁木齐',
    category: 'history',
    question: '左宗棠收复新疆的时间是？',
    options: ['1876-1878年', '1865-1867年', '1884-1885年', '1894-1895年'],
    answer: 0,
    explanation: '1876年左宗棠率军西征，至1878年收复了除伊犁以外的新疆全境，维护了国家领土完整。'
  },
  {
    id: 354,
    city: '乌鲁木齐',
    category: 'geography',
    question: '连接兰州与乌鲁木齐的高速铁路线是？',
    options: ['兰新高铁', '京新高铁', '青藏铁路', '川藏铁路'],
    answer: 0,
    explanation: '兰新高铁（兰新客运专线）连接兰州与乌鲁木齐，是世界上一次性建成里程最长的高速铁路。'
  },

  // ========== 拉萨 ==========
  {
    id: 375,
    city: '拉萨',
    category: 'history',
    question: '633年吐蕃赞普松赞干布迁都拉萨，"拉萨"藏语意为？',
    options: ['神佛之地', '雪域', '圣城', '河谷'],
    answer: 0,
    explanation: '"拉萨"在藏语中意为"神佛之地"或"圣地"，因佛教兴盛而得名，是藏传佛教的圣地。'
  },
  {
    id: 376,
    city: '拉萨',
    category: 'history',
    question: '唐文成公主入藏联姻的吐蕃赞普是？',
    options: ['松赞干布', '赤德祖赞', '赤松德赞', '朗达玛'],
    answer: 0,
    explanation: '公元641年，唐太宗将文成公主嫁给吐蕃赞普松赞干布，汉藏联姻促进了唐蕃经济文化交流。'
  },
  {
    id: 377,
    city: '拉萨',
    category: 'history',
    question: '1720年清廷平定准噶尔后在拉萨设的官员是？',
    options: ['驻藏大臣', '伊犁将军', '参赞大臣', '理藩院尚书'],
    answer: 0,
    explanation: '1727年清朝正式设立驻藏大臣，代表中央政府与达赖、班禅共同管理西藏事务，加强了对西藏的管辖。'
  },
  {
    id: 378,
    city: '拉萨',
    category: 'history',
    question: '1960年设拉萨市，所在自治区成立时间是？',
    options: ['1951年', '1959年', '1965年', '1979年'],
    answer: 2,
    explanation: '1965年9月，西藏自治区正式成立，拉萨成为西藏自治区首府。'
  },
  {
    id: 379,
    city: '拉萨',
    category: 'history',
    question: '1951年西藏和平解放所签订的协议名称是？',
    options: ['十七条协议', '二十九条协议', '北京条约', '拉萨条约'],
    answer: 0,
    explanation: '1951年5月23日，中央人民政府与西藏地方政府签订《关于和平解放西藏办法的协议》，简称"十七条协议"，西藏和平解放。'
  },
  {
    id: 380,
    city: '拉萨',
    category: 'history',
    question: '布达拉宫最初由松赞干布兴建，主要用途是？',
    options: ['迎娶文成公主的宫堡', '军事要塞', '行政中心', '宗庙'],
    answer: 0,
    explanation: '布达拉宫最初是吐蕃赞普松赞干布为迎娶文成公主而兴建的宫堡，后经历代扩建，成为历代达赖喇嘛的冬宫。'
  },
  {
    id: 381,
    city: '拉萨',
    category: 'geography',
    question: '拉萨市位于下列哪条河流中游？',
    options: ['拉萨河', '雅鲁藏布江', '怒江', '澜沧江'],
    answer: 0,
    explanation: '拉萨位于拉萨河中游河谷平原，拉萨河是雅鲁藏布江的重要支流。'
  },
  {
    id: 382,
    city: '拉萨',
    category: 'geography',
    question: '拉萨市区海拔约？',
    options: ['3650米', '4500米', '2200米', '5000米'],
    answer: 0,
    explanation: '拉萨市区海拔约3650米，是世界上海拔最高的省会城市之一，因日照充足，有"日光城"之称。'
  },
  {
    id: 383,
    city: '拉萨',
    category: 'geography',
    question: '拉萨气候类型是？',
    options: ['高原温带半干旱气候', '亚热带季风气候', '温带季风气候', '热带季风气候'],
    answer: 0,
    explanation: '拉萨地处青藏高原，属于高原温带半干旱气候，全年日照时间长，昼夜温差大，降水较少。'
  },
  {
    id: 387,
    city: '拉萨',
    category: 'geography',
    question: '八廓街环绕大昭寺，是拉萨著名的什么通道？',
    options: ['转经道', '商旅通道', '军事通道', '朝圣山道'],
    answer: 0,
    explanation: '八廓街是围绕大昭寺的转经道，是拉萨最著名的转经路线和传统街区，也是藏民族文化的集中展示地。'
  },
  {
    id: 388,
    city: '拉萨',
    category: 'geography',
    question: '纳木错位于拉萨以北当雄，是哪类湖泊？',
    options: ['高原咸水湖', '高山淡水湖', '堰塞湖', '火山口湖'],
    answer: 0,
    explanation: '纳木错是西藏第二大湖泊，也是我国第三大咸水湖，属于高原内陆咸水湖，是著名的佛教圣湖。'
  },

  // ========== 成都 ==========
  {
    id: 390,
    city: '成都',
    category: 'history',
    question: '三国时期成都为蜀汉国都，开国皇帝是？',
    options: ['刘备', '刘禅', '刘焉', '刘表'],
    answer: 0,
    explanation: '公元221年，刘备在成都称帝，国号汉，史称蜀汉，成都成为三国时期蜀汉的都城。'
  },
  {
    id: 391,
    city: '成都',
    category: 'history',
    question: '唐宋时成都号称"扬一益二"，"益"指哪个政区？',
    options: ['益州', '益县', '益路', '益郡'],
    answer: 0,
    explanation: '唐代有"扬一益二"之说，意为天下最繁华的城市，扬州第一，益州（成都）第二，反映了当时成都经济的繁荣。'
  },
  {
    id: 392,
    city: '成都',
    category: 'history',
    question: '都江堰是战国时期修建的水利工程，主持修建者是？',
    options: ['李冰父子', '郑国', '西门豹', '王景'],
    answer: 0,
    explanation: '都江堰由战国时期秦国蜀郡太守李冰父子主持修建，是世界上现存最古老的无坝引水工程，至今仍在发挥作用。'
  },
  {
    id: 393,
    city: '成都',
    category: 'history',
    question: '明末清初成都遭张献忠洗劫，张献忠建立的政权名是？',
    options: ['大西', '大顺', '大齐', '大周'],
    answer: 0,
    explanation: '明末农民起义领袖张献忠在成都建立大西政权，对四川地区造成了巨大破坏，人口锐减。'
  },
  {
    id: 397,
    city: '成都',
    category: 'geography',
    question: '成都位于下列哪个地形区？',
    options: ['成都平原', '川中丘陵', '川西高原', '川东平行岭谷'],
    answer: 0,
    explanation: '成都位于成都平原中部，成都平原是西南地区最大的平原，土壤肥沃，农业发达，被誉为"天府之国"。'
  },
  {
    id: 398,
    city: '成都',
    category: 'geography',
    question: '都江堰将下列哪条江分流灌溉成都平原？',
    options: ['岷江', '沱江', '嘉陵江', '涪江'],
    answer: 0,
    explanation: '都江堰建在岷江中游，将岷江水分流灌溉成都平原，使成都平原"水旱从人，不知饥馑"。'
  },
  {
    id: 399,
    city: '成都',
    category: 'geography',
    question: '成都气候类型是？',
    options: ['亚热带季风气候', '温带季风气候', '高原气候', '热带季风气候'],
    answer: 0,
    explanation: '成都位于四川盆地，属于亚热带季风气候，因盆地地形，冬季温暖，夏季闷热，多云雾。'
  },
  {
    id: 400,
    city: '成都',
    category: 'geography',
    question: '龙泉山是成都平原与下列哪一地形区的分界？',
    options: ['川中丘陵', '川西高原', '川东平行岭谷', '云贵高原'],
    answer: 0,
    explanation: '龙泉山是成都平原东侧的天然屏障，是成都平原与川中丘陵的地理分界线。'
  },
  {
    id: 402,
    city: '成都',
    category: 'geography',
    question: '武侯祠纪念的蜀汉丞相是？',
    options: ['诸葛亮', '关羽', '张飞', '赵云'],
    answer: 0,
    explanation: '武侯祠是纪念蜀汉丞相诸葛亮的祠堂，诸葛亮生前封武乡侯，死后谥忠武侯，因此得名。'
  },
  {
    id: 405,
    city: '成都',
    category: 'history',
    question: '三国蜀汉后主刘禅的乳名故事发生地"阿斗"与下列哪条典故相关？',
    options: ['乐不思蜀', '三顾茅庐', '白帝托孤', '走麦城'],
    answer: 0,
    explanation: '蜀汉灭亡后，后主刘禅被迁往洛阳，司马昭问他是否思念蜀国，刘禅回答"此间乐，不思蜀"，这就是"乐不思蜀"典故的由来。'
  },
  {
    id: 410,
    city: '成都',
    category: 'geography',
    question: '成都所在省的简称是？',
    options: ['川或蜀', '渝', '云或滇', '黔'],
    answer: 0,
    explanation: '成都是四川省省会，四川省简称"川"或"蜀"，因古为蜀国之地而得名。'
  },

  // ========== 宜宾 ==========
  {
    id: 423,
    city: '宜宾',
    category: 'geography',
    question: '宜宾被誉为"万里长江第一城"，因其位于？',
    options: ['金沙江与岷江交汇成长江处', '长江入海口', '长江上游源头', '长江三峡口'],
    answer: 0,
    explanation: '金沙江与岷江在宜宾汇合后始称长江，因此宜宾被誉为"万里长江第一城"。'
  },
  {
    id: 424,
    city: '宜宾',
    category: 'geography',
    question: '在宜宾汇合形成长江的两条江是？',
    options: ['金沙江与岷江', '沱江与嘉陵江', '乌江与赤水河', '雅砻江与大渡河'],
    answer: 0,
    explanation: '长江的正源是沱沱河，当流至宜宾与岷江汇合后，正式称为长江。金沙江是长江上游的名称。'
  },
  {
    id: 425,
    city: '宜宾',
    category: 'geography',
    question: '宜宾气候类型是？',
    options: ['亚热带季风气候', '温带季风气候', '高原气候', '热带季风气候'],
    answer: 0,
    explanation: '宜宾位于四川盆地南部，属于亚热带季风气候，温暖湿润，适合酿酒微生物生长，是著名的酒都。'
  },

  // ========== 昆明 ==========
  {
    id: 428,
    city: '昆明',
    category: 'history',
    question: '战国楚顷襄王派庄蹻入滇建国，国名是？',
    options: ['滇国', '夜郎', '巴蜀', '大滇'],
    answer: 0,
    explanation: '战国时期楚国将领庄蹻率军入滇，建立滇国，这是云南历史上第一个有记载的政权。'
  },
  {
    id: 431,
    city: '昆明',
    category: 'history',
    question: '1915年蔡锷在昆明誓师护国起义反对袁世凯称帝，起义名称是？',
    options: ['护国战争', '二次革命', '北伐战争', '辛亥革命'],
    answer: 0,
    explanation: '1915年12月，蔡锷、唐继尧等在云南昆明发动护国起义，组成护国军讨袁，护国战争爆发，最终迫使袁世凯取消帝制。'
  },
  {
    id: 433,
    city: '昆明',
    category: 'geography',
    question: '昆明位于下列哪一地形区？',
    options: ['云贵高原中部', '青藏高原东缘', '四川盆地南缘', '滇西纵谷'],
    answer: 0,
    explanation: '昆明位于云贵高原中部，海拔约1890米，是云南省省会。'
  },
  {
    id: 434,
    city: '昆明',
    category: 'geography',
    question: '昆明市区海拔约？',
    options: ['1890米', '2200米', '3650米', '4500米'],
    answer: 0,
    explanation: '昆明市区平均海拔约1890米，由于纬度低、海拔高，形成了四季如春的气候特点。'
  },
  {
    id: 435,
    city: '昆明',
    category: 'geography',
    question: '昆明气候类型是？',
    options: ['亚热带高原季风气候', '亚热带季风气候', '温带季风气候', '热带季风气候'],
    answer: 0,
    explanation: '昆明属于亚热带高原季风气候，由于海拔较高，夏季不热，冬季受西南暖气流影响不冷，四季如春。'
  },
  {
    id: 436,
    city: '昆明',
    category: 'geography',
    question: '昆明别称"春城"，其形成主要原因是？',
    options: ['低纬度+高海拔四季如春', '海洋性调节', '高纬度冬季短', '季风影响'],
    answer: 0,
    explanation: '昆明位于低纬度地区，但海拔较高，夏季因海拔高而凉爽，冬季因纬度低且受西南暖气流影响而温暖，四季如春，被誉为"春城"。'
  },
  {
    id: 437,
    city: '昆明',
    category: 'geography',
    question: '滇池位于昆明西南，是中国第几大淡水湖？',
    options: ['第六大', '第一大', '第三大', '第九大'],
    answer: 0,
    explanation: '滇池是云南省最大的淡水湖，面积约300平方公里，是我国第六大淡水湖，被誉为"高原明珠"。'
  },
  {
    id: 440,
    city: '昆明',
    category: 'history',
    question: '抗战时期昆明成为大后方重要城市，主要因下列哪条国际通道？',
    options: ['滇缅公路与驼峰航线', '京杭运河', '陇海铁路', '西伯利亚大铁路'],
    answer: 0,
    explanation: '抗日战争时期，滇缅公路和驼峰航线是中国获取外援的重要国际通道，昆明作为通道终点，成为抗战大后方的重要城市。'
  },

  // ========== 丽江 ==========
  {
    id: 445,
    city: '丽江',
    category: 'history',
    question: '丽江古城被列入《世界遗产名录》的时间是？',
    options: ['1997年', '2000年', '2005年', '2010年'],
    answer: 0,
    explanation: '1997年丽江古城被联合国教科文组织列入世界文化遗产名录，是我国保存最完整的古城之一。'
  },
  {
    id: 446,
    city: '丽江',
    category: 'geography',
    question: '玉龙雪山位于丽江北郊，主峰海拔约？',
    options: ['5596米', '4500米', '6300米', '7000米'],
    answer: 0,
    explanation: '玉龙雪山主峰扇子陡海拔5596米，是北半球纬度最低的雪山，终年积雪，是丽江的标志性景观。'
  },
  {
    id: 449,
    city: '丽江',
    category: 'geography',
    question: '泸沽湖位于丽江宁蒗县与四川凉山交界，是哪类湖泊？',
    options: ['高原断层湖', '火山口湖', '堰塞湖', '冰川湖'],
    answer: 0,
    explanation: '泸沽湖是由断层陷落形成的高原淡水湖泊，湖水清澈，是云南海拔最高的湖泊，湖畔居住着摩梭人。'
  },

  // ========== 西双版纳 ==========
  {
    id: 451,
    city: '西双版纳',
    category: 'history',
    question: '1953年成立的西双版纳属于哪种行政区？',
    options: ['傣族自治州', '自治县', '自治旗', '民族乡'],
    answer: 0,
    explanation: '西双版纳傣族自治州成立于1953年，是云南省下辖的民族自治州，首府为景洪市。'
  },
  {
    id: 452,
    city: '西双版纳',
    category: 'geography',
    question: '西双版纳气候类型是？',
    options: ['热带季风气候', '亚热带季风气候', '热带雨林气候', '高原气候'],
    answer: 0,
    explanation: '西双版纳位于北回归线以南，属于热带季风气候，全年高温，有明显的旱雨两季，是我国热带生态系统保存最完整的地区。'
  },
  {
    id: 454,
    city: '西双版纳',
    category: 'geography',
    question: '澜沧江流经西双版纳出境后改称？',
    options: ['湄公河', '萨尔温江', '伊洛瓦底江', '红河'],
    answer: 0,
    explanation: '澜沧江发源于青藏高原，流经西双版纳出境后称为湄公河，是东南亚最重要的国际河流，流经中、缅、老、泰、柬、越六国。'
  },
  {
    id: 455,
    city: '西双版纳',
    category: 'geography',
    question: '西双版纳是中国哪类生态系统保护核心？',
    options: ['热带生态保护', '温带草原', '高寒荒漠', '亚寒带针叶林'],
    answer: 0,
    explanation: '西双版纳拥有我国面积最大的热带雨林，是我国热带生态系统保护的核心区域，生物多样性极为丰富。'
  },

  // ========== 贵阳 ==========
  {
    id: 470,
    city: '贵阳',
    category: 'geography',
    question: '贵阳地处云贵高原的哪一部位？',
    options: ['东斜坡过渡带', '高原主体', '西部边缘', '北部山地'],
    answer: 0,
    explanation: '贵阳位于云贵高原东斜坡过渡地带，地势从西南向东北倾斜，喀斯特地貌发育典型。'
  },
  {
    id: 471,
    city: '贵阳',
    category: 'geography',
    question: '贵阳气候类型是？',
    options: ['亚热带季风气候', '温带季风气候', '高原气候', '热带季风气候'],
    answer: 0,
    explanation: '贵阳位于云贵高原，属于亚热带季风气候，因海拔较高，夏季凉爽，有"避暑之都"的美誉。'
  },
  {
    id: 472,
    city: '贵阳',
    category: 'geography',
    question: '贵阳因夏季凉爽被称为？',
    options: ['避暑之都', '春城', '火炉', '雾都'],
    answer: 0,
    explanation: '贵阳海拔约1100米，夏季平均气温舒适，是著名的避暑城市，被誉为"中国避暑之都"。'
  },
  {
    id: 476,
    city: '贵阳',
    category: 'geography',
    question: '贵阳是下列哪条高铁的节点城市？',
    options: ['沪昆高铁', '京沪高铁', '京广高铁', '兰新高铁'],
    answer: 0,
    explanation: '沪昆高铁连接上海与昆明，是我国东西向最长的高铁干线，贵阳是其中重要的枢纽站点。'
  },

  // ========== 南宁 ==========
  {
    id: 482,
    city: '南宁',
    category: 'history',
    question: '中国-东盟博览会永久举办地是？',
    options: ['南宁', '昆明', '广州', '海口'],
    answer: 0,
    explanation: '中国-东盟博览会永久落户南宁，每年举办一次，南宁因此成为中国面向东盟开放合作的前沿城市。'
  },
  {
    id: 483,
    city: '南宁',
    category: 'geography',
    question: '穿南宁市区而过的河流是？',
    options: ['邕江', '漓江', '柳江', '桂江'],
    answer: 0,
    explanation: '邕江是珠江水系西江的支流，穿南宁市区而过，是南宁的母亲河，南宁简称"邕"即源于此。'
  },
  {
    id: 484,
    city: '南宁',
    category: 'geography',
    question: '南宁气候类型是？',
    options: ['亚热带季风气候', '热带季风气候', '温带季风气候', '高原气候'],
    answer: 0,
    explanation: '南宁位于北回归线以南，属于亚热带季风气候，全年温暖湿润，植被四季常青，有"绿城"之称。'
  },
  {
    id: 485,
    city: '南宁',
    category: 'geography',
    question: '青秀山风景区位于南宁邕江畔，主要植被属于？',
    options: ['亚热带常绿阔叶林', '热带雨林', '温带落叶阔叶林', '亚寒带针叶林'],
    answer: 0,
    explanation: '南宁属于亚热带季风气候，地带性植被为亚热带常绿阔叶林，青秀山风景区植被茂密，是南宁的"绿肺"。'
  },

  // ========== 海口 ==========
  {
    id: 494,
    city: '海口',
    category: 'geography',
    question: '海口是哪一省省会？',
    options: ['海南省', '广东省', '广西壮族自治区', '福建省'],
    answer: 0,
    explanation: '海口是海南省省会，位于海南岛北部，隔琼州海峡与广东省雷州半岛相望。'
  },
  {
    id: 495,
    city: '海口',
    category: 'geography',
    question: '海口气候类型是？',
    options: ['热带海洋性气候', '亚热带季风气候', '热带季风气候', '温带季风气候'],
    answer: 0,
    explanation: '海口位于海南岛北部，濒临南海，属于热带海洋性气候，全年高温，分旱雨两季。'
  },

  // ========== 三亚 ==========
  {
    id: 497,
    city: '三亚',
    category: 'geography',
    question: '三亚是中国最南端地级市，所临海域是？',
    options: ['南海', '东海', '黄海', '渤海'],
    answer: 0,
    explanation: '三亚位于海南岛最南端，濒临南海，是我国最南端的地级市之一。'
  },
  {
    id: 498,
    city: '三亚',
    category: 'geography',
    question: '三亚气候类型是？',
    options: ['热带海洋性气候', '亚热带季风气候', '热带季风气候', '温带季风气候'],
    answer: 0,
    explanation: '三亚位于海南岛最南端，属于热带海洋性气候，全年高温，长夏无冬，是我国著名的热带滨海旅游城市。'
  },
  {
    id: 499,
    city: '三亚',
    category: 'geography',
    question: '亚龙湾位于三亚市东郊，被誉为？',
    options: ['天下第一湾', '东方之门', '南国明珠', '海上仙山'],
    answer: 0,
    explanation: '亚龙湾拥有7公里长的银白色海滩，沙质细腻，海水清澈，被誉为"天下第一湾"，是三亚最著名的旅游度假区。'
  },

  // ========== 基础财务 ==========
  {
    id: 500,
    city: '财务',
    category: 'finance',
    question: '航空公司本周机票收入100万元，燃油、机组、机场等成本82万元。不考虑其他项目，本周经营结果最接近哪一项？',
    options: ['收入18万元', '现金流82万元', '利润18万元', '成本100万元'],
    answer: 2,
    explanation: '利润可以先粗略理解为收入减去成本。100万元收入减去82万元成本，剩下18万元利润。'
  },
  {
    id: 501,
    city: '财务',
    category: 'finance',
    question: '为什么"收入高"不一定代表"赚钱多"？',
    options: ['因为收入只包括现金，不包括票款', '因为还要扣除成本和费用', '因为收入越高一定亏损', '因为收入不能用来还贷款'],
    answer: 1,
    explanation: '判断赚钱多少要看利润，利润不仅看收入，也要看燃油、工资、维修、机场费等成本费用。'
  },
  {
    id: 502,
    city: '财务',
    category: 'finance',
    question: '一条航线票价提高后，利润不一定增加，最可能的原因是？',
    options: ['票价提高后乘客可能变少', '飞机资产会立刻减少', '贷款本金会自动增加', '折旧会马上消失'],
    answer: 0,
    explanation: '票价变高可能让单张票收入增加，但如果乘客明显减少，总收入和利润反而可能下降。'
  },
  {
    id: 503,
    city: '财务',
    category: 'finance',
    question: '下列哪项最适合计入一次航班的运营成本？',
    options: ['乘客支付的机票款', '银行借入的一笔贷款', '公司拥有的一架飞机', '本次航班消耗的燃油费'],
    answer: 3,
    explanation: '燃油费是为了完成航班而发生的支出，属于运营成本；机票款是收入，贷款是融资。'
  },
  {
    id: 504,
    city: '财务',
    category: 'finance',
    question: '如果一条航线每周收入60万元、成本65万元，最合理的判断是？',
    options: ['航线一定值得扩张', '航线暂时处于亏损', '公司现金一定为零', '飞机价值下降5万元'],
    answer: 1,
    explanation: '成本65万元高于收入60万元，不考虑其他项目时，这条航线亏损5万元。'
  },
  {
    id: 505,
    city: '财务',
    category: 'finance',
    question: '"利润"最接近下面哪种说法？',
    options: ['公司手里所有现金', '银行愿意借给公司的钱', '收入扣除相关成本费用后的结果', '买飞机花掉的钱'],
    answer: 2,
    explanation: '利润衡量经营赚没赚钱，不等同于手里现金，也不等同于借款额度。'
  },
  {
    id: 506,
    city: '财务',
    category: 'finance',
    question: '航空公司想提高利润，下列做法最合理的是？',
    options: ['只增加航班数量，不看上座率', '降价到远低于成本', '把所有现金都用于买飞机', '提高收入质量并控制不必要成本'],
    answer: 3,
    explanation: '利润受收入和成本共同影响，合理定价、提高上座率、控制浪费，都比盲目扩张更稳。'
  },
  {
    id: 507,
    city: '财务',
    category: 'finance',
    question: '公司利润为正，但仍可能遇到现金压力，原因可能是？',
    options: ['利润不等于手上马上可用的现金', '有利润就不能借款', '现金只和收入有关', '利润越高现金越少是固定规律'],
    answer: 0,
    explanation: '利润是经营成果，现金是手上可支付的钱。应收款、购机支出、还贷款等都会影响现金。'
  },
  {
    id: 508,
    city: '财务',
    category: 'finance',
    question: '下列哪项最能说明"现金流入"？',
    options: ['支付维修费', '收到乘客票款', '偿还贷款本金', '支付燃油费'],
    answer: 1,
    explanation: '现金流入表示现金进入公司账户。乘客付款会带来现金流入，支付费用和还款是现金流出。'
  },
  {
    id: 509,
    city: '财务',
    category: 'finance',
    question: '下列哪项会造成现金流出，但不一定立刻全部变成利润表亏损？',
    options: ['收到机票收入', '银行发放贷款', '支付现金购买飞机', '乘客增加'],
    answer: 2,
    explanation: '买飞机会让现金流出，但飞机会成为资产，通常通过折旧在较长时间里影响利润。'
  },
  {
    id: 510,
    city: '财务',
    category: 'finance',
    question: '为什么经营公司要留一部分现金储备？',
    options: ['现金越多利润一定越高', '留现金会让负债自动减少', '留现金可以不用看成本', '可以应对还款、燃油、工资等近期支出'],
    answer: 3,
    explanation: '现金储备像缓冲垫，可以帮助公司按时支付近期账单，避免遇到突发支出时被动。'
  },
  {
    id: 511,
    city: '财务',
    category: 'finance',
    question: '银行贷款到账时，对公司最直接的影响是？',
    options: ['利润增加，同时成本消失', '现金增加，同时未来要还款', '资产减少，同时收入增加', '负债减少，同时现金增加'],
    answer: 1,
    explanation: '贷款到账会增加现金，但这笔钱不是收入，因为公司以后需要偿还，所以也会形成负债。'
  },
  {
    id: 512,
    city: '财务',
    category: 'finance',
    question: '公司偿还贷款本金时，最准确的说法是？',
    options: ['现金减少，负债减少', '现金减少，收入减少', '利润增加，负债增加', '成本减少，资产增加'],
    answer: 0,
    explanation: '还本金会用掉现金，同时减少欠银行的钱。本金偿还本身通常不是经营成本。'
  },
  {
    id: 513,
    city: '财务',
    category: 'finance',
    question: '"现金流紧张"最接近哪种情况？',
    options: ['本周乘客人数增加', '公司收入高于去年', '账上有飞机，但近期账单缺钱支付', '飞机折旧正常记录'],
    answer: 2,
    explanation: '有资产不代表马上有现金。现金流紧张重点是近期该付的钱缺少可用现金。'
  },
  {
    id: 514,
    city: '财务',
    category: 'finance',
    question: '"本金"和"利息"的区别是？',
    options: ['本金是收入，利息是资产', '本金不用还，利息才要还', '本金是利润，利息是现金', '本金是借来的原始金额，利息是借钱要付的成本'],
    answer: 3,
    explanation: '本金是最初借来的钱，利息是使用这笔钱需要额外支付给银行的成本。'
  },
  {
    id: 515,
    city: '财务',
    category: 'finance',
    question: '公司用贷款买飞机的一个优点是？',
    options: ['不需要考虑未来还款', '可以减少一次性现金压力', '飞机不再需要维护', '利息会变成收入'],
    answer: 1,
    explanation: '贷款能让公司不用一次付完整个购机款，但之后仍要按期还本付息。'
  },
  {
    id: 516,
    city: '财务',
    category: 'finance',
    question: '贷款过多最容易带来什么问题？',
    options: ['资产一定变少', '飞机无法产生收入', '每期还款和利息压力变大', '收入自动下降为零'],
    answer: 2,
    explanation: '贷款越多，未来要还的本金和利息通常越多，现金压力也会更大。'
  },
  {
    id: 517,
    city: '财务',
    category: 'finance',
    question: '利率上升时，借同样的钱通常意味着？',
    options: ['总利息成本更高', '本金减少', '现金流入减少为零', '飞机折旧停止'],
    answer: 0,
    explanation: '利率可以理解为借钱的价格。利率越高，同样本金对应的利息成本通常越高。'
  },
  {
    id: 518,
    city: '财务',
    category: 'finance',
    question: '支付贷款利息通常属于什么？',
    options: ['资本开支', '财务费用', '机票收入', '现金资产'],
    answer: 1,
    explanation: '利息是为了借钱而付出的费用，通常归入财务费用，会影响利润。'
  },
  {
    id: 519,
    city: '财务',
    category: 'finance',
    question: '提前还一部分贷款本金，通常会带来什么变化？',
    options: ['收入立刻增加', '飞机数量增加', '成本永远为零', '负债减少，未来利息可能减少'],
    answer: 3,
    explanation: '提前还本金会减少欠款余额，欠款余额降低后，未来按余额计算的利息也可能减少。'
  },
  {
    id: 520,
    city: '财务',
    category: 'finance',
    question: '下列哪项最像航空公司的资产？',
    options: ['尚未偿还的银行贷款', '未来需要支付的利息', '公司拥有的飞机', '本月亏损金额'],
    answer: 2,
    explanation: '资产是公司拥有或控制、能带来价值的资源。飞机能用于运营航班，因此属于资产。'
  },
  {
    id: 521,
    city: '财务',
    category: 'finance',
    question: '下列哪项最像负债？',
    options: ['公司账户现金', '尚未还清的贷款', '已购买的燃油库存', '已拥有的飞机'],
    answer: 1,
    explanation: '负债是公司未来需要偿还或履行的义务，尚未还清的贷款就是典型负债。'
  },
  {
    id: 522,
    city: '财务',
    category: 'finance',
    question: '"净资产"可以初步理解为？',
    options: ['资产减去负债后属于公司的价值', '本周收入减本周燃油费', '公司所有贷款总额', '现金流入减现金流出'],
    answer: 0,
    explanation: '净资产可以简单理解为公司拥有的资产扣掉欠款后，真正属于公司的那部分价值。'
  },
  {
    id: 523,
    city: '财务',
    category: 'finance',
    question: '公司用现金购买飞机后，最准确的说法是？',
    options: ['资产一定减少为零', '负债一定增加', '利润一定增加', '现金资产减少，飞机资产增加'],
    answer: 3,
    explanation: '现金买飞机会减少现金，但增加飞机资产；这不是简单地等于公司立刻亏掉购机款。'
  },
  {
    id: 524,
    city: '财务',
    category: 'finance',
    question: '公司贷款购买飞机后，通常会同时出现什么？',
    options: ['只有收入增加', '现金永远不变', '飞机资产增加，贷款负债也增加', '利润立刻增加'],
    answer: 2,
    explanation: '贷款购机会让公司获得飞机资产，同时也形成需要未来偿还的贷款负债。'
  },
  {
    id: 525,
    city: '财务',
    category: 'finance',
    question: '下列哪项更像固定成本？',
    options: ['不随短期航班数量明显变化的办公室租金', '每多飞一班增加的燃油', '按航班次数支付的起降费', '每位乘客的餐食成本'],
    answer: 0,
    explanation: '固定成本在短期内不太随业务量变化。办公室租金通常不像燃油那样随航班数量立刻增加。'
  },
  {
    id: 526,
    city: '财务',
    category: 'finance',
    question: '下列哪项更像变动成本？',
    options: ['总部固定租金', '固定管理人员基本工资', '公司品牌名称', '飞行越多消耗越多的燃油'],
    answer: 3,
    explanation: '变动成本会随着业务量变化。航班越多、飞行越多，燃油消耗通常越多。'
  },
  {
    id: 527,
    city: '财务',
    category: 'finance',
    question: '为什么上座率低会影响盈利？',
    options: ['贷款不用还', '收入减少，但很多成本仍然存在', '飞机资产会自动消失', '燃油价格一定下降'],
    answer: 1,
    explanation: '座位没卖出去会减少收入，但机组、起降、折旧、贷款等不少支出仍然存在。'
  },
  {
    id: 528,
    city: '财务',
    category: 'finance',
    question: '固定成本高的公司，最需要注意什么？',
    options: ['固定成本越高越安全', '固定成本不会影响利润', '即使收入下降，也可能仍要支付不少费用', '固定成本只影响飞机速度'],
    answer: 2,
    explanation: '固定成本不会因为收入下降就马上消失，所以固定成本高的公司更需要稳定收入和现金储备。'
  },
  {
    id: 529,
    city: '财务',
    category: 'finance',
    question: '如果航班增加，燃油费通常也增加，这说明燃油费具有哪种特点？',
    options: ['更接近变动成本', '更接近收入', '更接近负债本金', '更接近净资产'],
    answer: 0,
    explanation: '燃油费会随着飞行量变化，飞得越多通常花得越多，所以更接近变动成本。'
  },
  {
    id: 530,
    city: '财务',
    category: 'finance',
    question: '公司准备买飞机前，为什么要做预算？',
    options: ['为了让收入自动增加', '为了估计买完后是否还有钱维持运营', '为了不用记录成本', '为了让贷款不用还'],
    answer: 1,
    explanation: '预算能帮助公司提前估计购机款、还款、燃油、维修等支出，避免买完飞机后现金不够。'
  },
  {
    id: 531,
    city: '财务',
    category: 'finance',
    question: '"把钱全部花光去扩张"可能有什么风险？',
    options: ['飞机一定更便宜', '利润一定增加', '负债一定消失', '未来遇到燃油、工资、还款时缺现金'],
    answer: 3,
    explanation: '扩张需要现金支持。现金全部花光后，遇到日常账单或突发支出时容易陷入被动。'
  },
  {
    id: 532,
    city: '财务',
    category: 'finance',
    question: '下列哪种做法更稳健？',
    options: ['只看飞机价格，不看后续运营成本', '现金越少越容易经营', '买飞机前同时考虑首付、还款、燃油和维修', '收入没稳定前尽量借满贷款'],
    answer: 2,
    explanation: '稳健经营不仅看买入价格，也要看后续能不能承担还款、燃油、维修和人员等支出。'
  },
  {
    id: 533,
    city: '财务',
    category: 'finance',
    question: '飞机使用几年后，账面价值通常会下降，这种现象最接近什么？',
    options: ['收入', '折旧', '股息', '本金'],
    answer: 1,
    explanation: '折旧表示长期资产在使用过程中价值逐步消耗。飞机越旧，账面价值通常会逐步下降。'
  },
  {
    id: 534,
    city: '财务',
    category: 'finance',
    question: '为什么卖旧飞机时，卖价可能低于当初购买价？',
    options: ['因为飞机使用后会磨损、变旧', '因为收入太高', '因为负债一定增加', '因为现金流入不能记录'],
    answer: 0,
    explanation: '飞机使用后会老化、磨损，维护状态和市场需求也会影响二手价格，所以卖价可能低于购买价。'
  },
];

function withAnswerAt(question: QuizQuestion, targetAnswer: number): QuizQuestion {
  if (question.answer === targetAnswer) return question;
  const correctOption = question.options[question.answer];
  const otherOptions = question.options.filter((_, index) => index !== question.answer);
  const options = [...otherOptions];
  options.splice(targetAnswer, 0, correctOption);
  return { ...question, options, answer: targetAnswer };
}

function normalizeQuestionOptions(question: QuizQuestion): QuizQuestion {
  if (question.category === 'finance') return question;
  return withAnswerAt(question, question.id % question.options.length);
}

export const QUIZ_QUESTIONS: QuizQuestion[] = RAW_QUIZ_QUESTIONS.map(normalizeQuestionOptions);
